/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as PolicyImport } from './routes/policy'
import { Route as LoginStageImport } from './routes/login-stage'
import { Route as IndexImport } from './routes/index'
import { Route as SignUpIndexImport } from './routes/sign-up/index'
import { Route as SignUpPetImport } from './routes/sign-up/pet'
import { Route as SignUpCustomerDoneImport } from './routes/sign-up/customer-done'
import { Route as SignUpCustomerImport } from './routes/sign-up/customer'
import { Route as SignUpBusinessTeacherDoneImport } from './routes/sign-up/business-teacher-done'
import { Route as SignUpBusinessTeacherImport } from './routes/sign-up/business-teacher'
import { Route as SignUpBusinessOwnerDoneImport } from './routes/sign-up/business-owner-done'
import { Route as SignUpBusinessOwnerDetailImport } from './routes/sign-up/business-owner-detail'
import { Route as SignUpBusinessOwnerImport } from './routes/sign-up/business-owner'
import { Route as OauthNaverImport } from './routes/oauth/naver'
import { Route as OauthKakaoImport } from './routes/oauth/kakao'
import { Route as OauthGoogleImport } from './routes/oauth/google'
import { Route as CustomerLayoutImport } from './routes/customer/layout'
import { Route as CustomerAlertImport } from './routes/customer/alert'
import { Route as BusinessLayoutImport } from './routes/business/layout'
import { Route as AuthHandoffImport } from './routes/auth/handoff'
import { Route as OauthGoogleCallbackImport } from './routes/oauth/google/callback'
import { Route as CustomerLayoutUserUsageHistoryDetailImport } from './routes/customer/layout/user-usage-history-detail'
import { Route as CustomerLayoutUserUsageHistoryImport } from './routes/customer/layout/user-usage-history'
import { Route as CustomerLayoutUserSubscriptionsImport } from './routes/customer/layout/user-subscriptions'
import { Route as CustomerLayoutUserSubscriptionDetailImport } from './routes/customer/layout/user-subscription-detail'
import { Route as CustomerLayoutUserPushImport } from './routes/customer/layout/user-push'
import { Route as CustomerLayoutUserPetInfoChgImport } from './routes/customer/layout/user-pet-info-chg'
import { Route as CustomerLayoutUserPetInfoAddImport } from './routes/customer/layout/user-pet-info-add'
import { Route as CustomerLayoutUserPetInfoImport } from './routes/customer/layout/user-pet-info'
import { Route as CustomerLayoutUserInfoChgImport } from './routes/customer/layout/user-info-Chg'
import { Route as CustomerLayoutUserGuardianLinkImport } from './routes/customer/layout/user-guardian-link'
import { Route as CustomerLayoutUserContractDetailImport } from './routes/customer/layout/user-contract-detail'
import { Route as CustomerLayoutUserContractImport } from './routes/customer/layout/user-contract'
import { Route as CustomerLayoutUserBuyCoinImport } from './routes/customer/layout/user-buy-coin'
import { Route as CustomerLayoutUserAnnouncementDetailImport } from './routes/customer/layout/user-announcement-detail'
import { Route as CustomerLayoutUserAnnouncementImport } from './routes/customer/layout/user-announcement'
import { Route as CustomerLayoutUserImport } from './routes/customer/layout/user'
import { Route as CustomerLayoutToSchoolImport } from './routes/customer/layout/to-school'
import { Route as CustomerLayoutSubscriptionListImport } from './routes/customer/layout/subscription-list'
import { Route as CustomerLayoutSearchImport } from './routes/customer/layout/search'
import { Route as CustomerLayoutReservationWithSubscriptionImport } from './routes/customer/layout/reservation-with-subscription'
import { Route as CustomerLayoutReservationImport } from './routes/customer/layout/reservation'
import { Route as CustomerLayoutMemberCodeImport } from './routes/customer/layout/member-code'
import { Route as CustomerLayoutMapListImport } from './routes/customer/layout/map-list'
import { Route as CustomerLayoutMapImport } from './routes/customer/layout/map'
import { Route as CustomerLayoutInquiryHistoryImport } from './routes/customer/layout/inquiry-history'
import { Route as CustomerLayoutInformSendFixImport } from './routes/customer/layout/inform-send-fix'
import { Route as CustomerLayoutInformSendImport } from './routes/customer/layout/inform-send'
import { Route as CustomerLayoutInformDetailImport } from './routes/customer/layout/inform-detail'
import { Route as CustomerLayoutInformImport } from './routes/customer/layout/inform'
import { Route as CustomerLayoutInfoSuggestImport } from './routes/customer/layout/info-suggest'
import { Route as CustomerLayoutHomeSerachStoreImport } from './routes/customer/layout/home-serach-store'
import { Route as CustomerLayoutHomeSerachDetailImport } from './routes/customer/layout/home-serach-detail'
import { Route as CustomerLayoutHomeAlertImport } from './routes/customer/layout/home-alert'
import { Route as CustomerLayoutHomeImport } from './routes/customer/layout/home'
import { Route as CustomerLayoutGalleryDetailImport } from './routes/customer/layout/gallery-detail'
import { Route as CustomerLayoutGalleryImport } from './routes/customer/layout/gallery'
import { Route as CustomerLayoutContractSignImport } from './routes/customer/layout/contract-sign'
import { Route as CustomerLayoutContractInboxImport } from './routes/customer/layout/contract-inbox'
import { Route as CustomerLayoutCalendarReservationChgImport } from './routes/customer/layout/calendar-reservation-chg'
import { Route as CustomerLayoutCalendarReservationImport } from './routes/customer/layout/calendar-reservation'
import { Route as CustomerLayoutCalendarImport } from './routes/customer/layout/calendar'
import { Route as CustomerLayoutAboutImport } from './routes/customer/layout/about'
import { Route as BusinessLayoutUserTeacherSettingImport } from './routes/business/layout/user-teacher-setting'
import { Route as BusinessLayoutUserTeacherPushImport } from './routes/business/layout/user-teacher-push'
import { Route as BusinessLayoutUserTeacherInfoImport } from './routes/business/layout/user-teacher-info'
import { Route as BusinessLayoutUserSubscriptionOrderEditImport } from './routes/business/layout/user-subscription-order-edit'
import { Route as BusinessLayoutUserSubscriptionManagementImport } from './routes/business/layout/user-subscription-management'
import { Route as BusinessLayoutUserSubscriptionIssueHistoryImport } from './routes/business/layout/user-subscription-issue-history'
import { Route as BusinessLayoutUserSubscriptionIssueDetailImport } from './routes/business/layout/user-subscription-issue-detail'
import { Route as BusinessLayoutUserSubscriptionIssueImport } from './routes/business/layout/user-subscription-issue'
import { Route as BusinessLayoutUserSubscriptionAddEditImport } from './routes/business/layout/user-subscription-add-edit'
import { Route as BusinessLayoutUserServiceStatisticsImport } from './routes/business/layout/user-service-statistics'
import { Route as BusinessLayoutUserProductManagementImport } from './routes/business/layout/user-product-management'
import { Route as BusinessLayoutUserPaymentHistoryImport } from './routes/business/layout/user-payment-history'
import { Route as BusinessLayoutUserOwnerSettingImport } from './routes/business/layout/user-owner-setting'
import { Route as BusinessLayoutUserOwnerPushImport } from './routes/business/layout/user-owner-push'
import { Route as BusinessLayoutUserOwnerInfoImport } from './routes/business/layout/user-owner-info'
import { Route as BusinessLayoutUserOwnerAnnouncementDetailImport } from './routes/business/layout/user-owner-announcement-detail'
import { Route as BusinessLayoutUserOwnerAnnouncementImport } from './routes/business/layout/user-owner-announcement'
import { Route as BusinessLayoutUserEmployeeManagementImport } from './routes/business/layout/user-employee-management'
import { Route as BusinessLayoutUserEmployeeDetailImport } from './routes/business/layout/user-employee-detail'
import { Route as BusinessLayoutUserCustomerManagementDetailImport } from './routes/business/layout/user-customer-management-detail'
import { Route as BusinessLayoutUserCustomerManagementImport } from './routes/business/layout/user-customer-management'
import { Route as BusinessLayoutUserCustomerInfoImport } from './routes/business/layout/user-customer-info'
import { Route as BusinessLayoutUserCreditWalletChargeSuccessImport } from './routes/business/layout/user-credit-wallet-charge-success'
import { Route as BusinessLayoutUserCreditWalletChargeFailImport } from './routes/business/layout/user-credit-wallet-charge-fail'
import { Route as BusinessLayoutUserCreditWalletChargeImport } from './routes/business/layout/user-credit-wallet-charge'
import { Route as BusinessLayoutUserCreditWalletImport } from './routes/business/layout/user-credit-wallet'
import { Route as BusinessLayoutUserContractManagementOldImport } from './routes/business/layout/user-contract-managementOld'
import { Route as BusinessLayoutUserContractManagementImport } from './routes/business/layout/user-contract-management'
import { Route as BusinessLayoutUserContractDetailImport } from './routes/business/layout/user-contract-detail'
import { Route as BusinessLayoutUserBusinessTimeManagementImport } from './routes/business/layout/user-business-time-management'
import { Route as BusinessLayoutUserBusinessPhotoManagementImport } from './routes/business/layout/user-business-photo-management'
import { Route as BusinessLayoutUserBusinessInfoImport } from './routes/business/layout/user-business-info'
import { Route as BusinessLayoutUserImport } from './routes/business/layout/user'
import { Route as BusinessLayoutToSchoolImport } from './routes/business/layout/to-school'
import { Route as BusinessLayoutTeacherImport } from './routes/business/layout/teacher'
import { Route as BusinessLayoutSealManagementImport } from './routes/business/layout/seal-management'
import { Route as BusinessLayoutRevservationImport } from './routes/business/layout/revservation'
import { Route as BusinessLayoutReservationWithIssuedTicketImport } from './routes/business/layout/reservation-with-issued-ticket'
import { Route as BusinessLayoutNotifyStyleImport } from './routes/business/layout/notify-style'
import { Route as BusinessLayoutNotifySendImport } from './routes/business/layout/notify-send'
import { Route as BusinessLayoutNotifySavedNotifyImport } from './routes/business/layout/notify-saved-notify'
import { Route as BusinessLayoutNotifyDetailImport } from './routes/business/layout/notify-detail'
import { Route as BusinessLayoutNotifyBatchImport } from './routes/business/layout/notify-batch'
import { Route as BusinessLayoutNotifyImport } from './routes/business/layout/notify'
import { Route as BusinessLayoutManualReserveImport } from './routes/business/layout/manual-reserve'
import { Route as BusinessLayoutHomeImport } from './routes/business/layout/home'
import { Route as BusinessLayoutGalleryAddImport } from './routes/business/layout/gallery-add'
import { Route as BusinessLayoutGalleryImport } from './routes/business/layout/gallery'
import { Route as BusinessLayoutContractTemplatesImport } from './routes/business/layout/contract-templates'
import { Route as BusinessLayoutContractTemplateImportImport } from './routes/business/layout/contract-template-import'
import { Route as BusinessLayoutContractTemplateEditImport } from './routes/business/layout/contract-template-edit'
import { Route as BusinessLayoutContractStatusImport } from './routes/business/layout/contract-status'
import { Route as BusinessLayoutContractRequestSendImport } from './routes/business/layout/contract-request-send'
import { Route as BusinessLayoutContractRequestDetailImport } from './routes/business/layout/contract-request-detail'
import { Route as BusinessLayoutCompanyPhotoAddImport } from './routes/business/layout/company-photo-add'
import { Route as BusinessLayoutCalendarImport } from './routes/business/layout/calendar'
import { Route as BusinessLayoutAboutImport } from './routes/business/layout/about'
import { Route as CustomerLayoutPaymentIndexImport } from './routes/customer/layout/payment/index'
import { Route as CustomerLayoutPaymentSuccessImport } from './routes/customer/layout/payment/success'
import { Route as CustomerLayoutPaymentIndexcopyImport } from './routes/customer/layout/payment/index copy'
import { Route as CustomerLayoutPaymentFailImport } from './routes/customer/layout/payment/fail'
import { Route as CustomerLayoutPaymentAuthImport } from './routes/customer/layout/payment/auth'
import { Route as BusinessLayoutPaymentTestImport } from './routes/business/layout/payment/test'

// Create Virtual Routes

const CustomerLayoutTestLazyImport = createFileRoute('/customer/layout/test')()
const BusinessLayoutTestLazyImport = createFileRoute('/business/layout/test')()

// Create/Update Routes

const SignUpRoute = SignUpImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const PolicyRoute = PolicyImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => rootRoute,
} as any)

const LoginStageRoute = LoginStageImport.update({
  id: '/login-stage',
  path: '/login-stage',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SignUpIndexRoute = SignUpIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SignUpRoute,
} as any)

const SignUpPetRoute = SignUpPetImport.update({
  id: '/pet',
  path: '/pet',
  getParentRoute: () => SignUpRoute,
} as any)

const SignUpCustomerDoneRoute = SignUpCustomerDoneImport.update({
  id: '/customer-done',
  path: '/customer-done',
  getParentRoute: () => SignUpRoute,
} as any)

const SignUpCustomerRoute = SignUpCustomerImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => SignUpRoute,
} as any)

const SignUpBusinessTeacherDoneRoute = SignUpBusinessTeacherDoneImport.update({
  id: '/business-teacher-done',
  path: '/business-teacher-done',
  getParentRoute: () => SignUpRoute,
} as any)

const SignUpBusinessTeacherRoute = SignUpBusinessTeacherImport.update({
  id: '/business-teacher',
  path: '/business-teacher',
  getParentRoute: () => SignUpRoute,
} as any)

const SignUpBusinessOwnerDoneRoute = SignUpBusinessOwnerDoneImport.update({
  id: '/business-owner-done',
  path: '/business-owner-done',
  getParentRoute: () => SignUpRoute,
} as any)

const SignUpBusinessOwnerDetailRoute = SignUpBusinessOwnerDetailImport.update({
  id: '/business-owner-detail',
  path: '/business-owner-detail',
  getParentRoute: () => SignUpRoute,
} as any)

const SignUpBusinessOwnerRoute = SignUpBusinessOwnerImport.update({
  id: '/business-owner',
  path: '/business-owner',
  getParentRoute: () => SignUpRoute,
} as any)

const OauthNaverRoute = OauthNaverImport.update({
  id: '/oauth/naver',
  path: '/oauth/naver',
  getParentRoute: () => rootRoute,
} as any)

const OauthKakaoRoute = OauthKakaoImport.update({
  id: '/oauth/kakao',
  path: '/oauth/kakao',
  getParentRoute: () => rootRoute,
} as any)

const OauthGoogleRoute = OauthGoogleImport.update({
  id: '/oauth/google',
  path: '/oauth/google',
  getParentRoute: () => rootRoute,
} as any)

const CustomerLayoutRoute = CustomerLayoutImport.update({
  id: '/customer/layout',
  path: '/customer/layout',
  getParentRoute: () => rootRoute,
} as any)

const CustomerAlertRoute = CustomerAlertImport.update({
  id: '/customer/alert',
  path: '/customer/alert',
  getParentRoute: () => rootRoute,
} as any)

const BusinessLayoutRoute = BusinessLayoutImport.update({
  id: '/business/layout',
  path: '/business/layout',
  getParentRoute: () => rootRoute,
} as any)

const AuthHandoffRoute = AuthHandoffImport.update({
  id: '/auth/handoff',
  path: '/auth/handoff',
  getParentRoute: () => rootRoute,
} as any)

const CustomerLayoutTestLazyRoute = CustomerLayoutTestLazyImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => CustomerLayoutRoute,
} as any).lazy(() =>
  import('./routes/customer/layout/test.lazy').then((d) => d.Route),
)

const BusinessLayoutTestLazyRoute = BusinessLayoutTestLazyImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => BusinessLayoutRoute,
} as any).lazy(() =>
  import('./routes/business/layout/test.lazy').then((d) => d.Route),
)

const OauthGoogleCallbackRoute = OauthGoogleCallbackImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => OauthGoogleRoute,
} as any)

const CustomerLayoutUserUsageHistoryDetailRoute =
  CustomerLayoutUserUsageHistoryDetailImport.update({
    id: '/user-usage-history-detail',
    path: '/user-usage-history-detail',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserUsageHistoryRoute =
  CustomerLayoutUserUsageHistoryImport.update({
    id: '/user-usage-history',
    path: '/user-usage-history',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserSubscriptionsRoute =
  CustomerLayoutUserSubscriptionsImport.update({
    id: '/user-subscriptions',
    path: '/user-subscriptions',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserSubscriptionDetailRoute =
  CustomerLayoutUserSubscriptionDetailImport.update({
    id: '/user-subscription-detail',
    path: '/user-subscription-detail',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserPushRoute = CustomerLayoutUserPushImport.update({
  id: '/user-push',
  path: '/user-push',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutUserPetInfoChgRoute =
  CustomerLayoutUserPetInfoChgImport.update({
    id: '/user-pet-info-chg',
    path: '/user-pet-info-chg',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserPetInfoAddRoute =
  CustomerLayoutUserPetInfoAddImport.update({
    id: '/user-pet-info-add',
    path: '/user-pet-info-add',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserPetInfoRoute = CustomerLayoutUserPetInfoImport.update({
  id: '/user-pet-info',
  path: '/user-pet-info',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutUserInfoChgRoute = CustomerLayoutUserInfoChgImport.update({
  id: '/user-info-Chg',
  path: '/user-info-Chg',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutUserGuardianLinkRoute =
  CustomerLayoutUserGuardianLinkImport.update({
    id: '/user-guardian-link',
    path: '/user-guardian-link',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserContractDetailRoute =
  CustomerLayoutUserContractDetailImport.update({
    id: '/user-contract-detail',
    path: '/user-contract-detail',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserContractRoute = CustomerLayoutUserContractImport.update(
  {
    id: '/user-contract',
    path: '/user-contract',
    getParentRoute: () => CustomerLayoutRoute,
  } as any,
)

const CustomerLayoutUserBuyCoinRoute = CustomerLayoutUserBuyCoinImport.update({
  id: '/user-buy-coin',
  path: '/user-buy-coin',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutUserAnnouncementDetailRoute =
  CustomerLayoutUserAnnouncementDetailImport.update({
    id: '/user-announcement-detail',
    path: '/user-announcement-detail',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserAnnouncementRoute =
  CustomerLayoutUserAnnouncementImport.update({
    id: '/user-announcement',
    path: '/user-announcement',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutUserRoute = CustomerLayoutUserImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutToSchoolRoute = CustomerLayoutToSchoolImport.update({
  id: '/to-school',
  path: '/to-school',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutSubscriptionListRoute =
  CustomerLayoutSubscriptionListImport.update({
    id: '/subscription-list',
    path: '/subscription-list',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutSearchRoute = CustomerLayoutSearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutReservationWithSubscriptionRoute =
  CustomerLayoutReservationWithSubscriptionImport.update({
    id: '/reservation-with-subscription',
    path: '/reservation-with-subscription',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutReservationRoute = CustomerLayoutReservationImport.update({
  id: '/reservation',
  path: '/reservation',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutMemberCodeRoute = CustomerLayoutMemberCodeImport.update({
  id: '/member-code',
  path: '/member-code',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutMapListRoute = CustomerLayoutMapListImport.update({
  id: '/map-list',
  path: '/map-list',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutMapRoute = CustomerLayoutMapImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutInquiryHistoryRoute =
  CustomerLayoutInquiryHistoryImport.update({
    id: '/inquiry-history',
    path: '/inquiry-history',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutInformSendFixRoute =
  CustomerLayoutInformSendFixImport.update({
    id: '/inform-send-fix',
    path: '/inform-send-fix',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutInformSendRoute = CustomerLayoutInformSendImport.update({
  id: '/inform-send',
  path: '/inform-send',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutInformDetailRoute = CustomerLayoutInformDetailImport.update(
  {
    id: '/inform-detail',
    path: '/inform-detail',
    getParentRoute: () => CustomerLayoutRoute,
  } as any,
)

const CustomerLayoutInformRoute = CustomerLayoutInformImport.update({
  id: '/inform',
  path: '/inform',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutInfoSuggestRoute = CustomerLayoutInfoSuggestImport.update({
  id: '/info-suggest',
  path: '/info-suggest',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutHomeSerachStoreRoute =
  CustomerLayoutHomeSerachStoreImport.update({
    id: '/home-serach-store',
    path: '/home-serach-store',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutHomeSerachDetailRoute =
  CustomerLayoutHomeSerachDetailImport.update({
    id: '/home-serach-detail',
    path: '/home-serach-detail',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutHomeAlertRoute = CustomerLayoutHomeAlertImport.update({
  id: '/home-alert',
  path: '/home-alert',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutHomeRoute = CustomerLayoutHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutGalleryDetailRoute =
  CustomerLayoutGalleryDetailImport.update({
    id: '/gallery-detail',
    path: '/gallery-detail',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutGalleryRoute = CustomerLayoutGalleryImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutContractSignRoute = CustomerLayoutContractSignImport.update(
  {
    id: '/contract-sign',
    path: '/contract-sign',
    getParentRoute: () => CustomerLayoutRoute,
  } as any,
)

const CustomerLayoutContractInboxRoute =
  CustomerLayoutContractInboxImport.update({
    id: '/contract-inbox',
    path: '/contract-inbox',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutCalendarReservationChgRoute =
  CustomerLayoutCalendarReservationChgImport.update({
    id: '/calendar-reservation-chg',
    path: '/calendar-reservation-chg',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutCalendarReservationRoute =
  CustomerLayoutCalendarReservationImport.update({
    id: '/calendar-reservation',
    path: '/calendar-reservation',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutCalendarRoute = CustomerLayoutCalendarImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutAboutRoute = CustomerLayoutAboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const BusinessLayoutUserTeacherSettingRoute =
  BusinessLayoutUserTeacherSettingImport.update({
    id: '/user-teacher-setting',
    path: '/user-teacher-setting',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserTeacherPushRoute =
  BusinessLayoutUserTeacherPushImport.update({
    id: '/user-teacher-push',
    path: '/user-teacher-push',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserTeacherInfoRoute =
  BusinessLayoutUserTeacherInfoImport.update({
    id: '/user-teacher-info',
    path: '/user-teacher-info',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserSubscriptionOrderEditRoute =
  BusinessLayoutUserSubscriptionOrderEditImport.update({
    id: '/user-subscription-order-edit',
    path: '/user-subscription-order-edit',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserSubscriptionManagementRoute =
  BusinessLayoutUserSubscriptionManagementImport.update({
    id: '/user-subscription-management',
    path: '/user-subscription-management',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserSubscriptionIssueHistoryRoute =
  BusinessLayoutUserSubscriptionIssueHistoryImport.update({
    id: '/user-subscription-issue-history',
    path: '/user-subscription-issue-history',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserSubscriptionIssueDetailRoute =
  BusinessLayoutUserSubscriptionIssueDetailImport.update({
    id: '/user-subscription-issue-detail',
    path: '/user-subscription-issue-detail',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserSubscriptionIssueRoute =
  BusinessLayoutUserSubscriptionIssueImport.update({
    id: '/user-subscription-issue',
    path: '/user-subscription-issue',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserSubscriptionAddEditRoute =
  BusinessLayoutUserSubscriptionAddEditImport.update({
    id: '/user-subscription-add-edit',
    path: '/user-subscription-add-edit',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserServiceStatisticsRoute =
  BusinessLayoutUserServiceStatisticsImport.update({
    id: '/user-service-statistics',
    path: '/user-service-statistics',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserProductManagementRoute =
  BusinessLayoutUserProductManagementImport.update({
    id: '/user-product-management',
    path: '/user-product-management',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserPaymentHistoryRoute =
  BusinessLayoutUserPaymentHistoryImport.update({
    id: '/user-payment-history',
    path: '/user-payment-history',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserOwnerSettingRoute =
  BusinessLayoutUserOwnerSettingImport.update({
    id: '/user-owner-setting',
    path: '/user-owner-setting',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserOwnerPushRoute =
  BusinessLayoutUserOwnerPushImport.update({
    id: '/user-owner-push',
    path: '/user-owner-push',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserOwnerInfoRoute =
  BusinessLayoutUserOwnerInfoImport.update({
    id: '/user-owner-info',
    path: '/user-owner-info',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserOwnerAnnouncementDetailRoute =
  BusinessLayoutUserOwnerAnnouncementDetailImport.update({
    id: '/user-owner-announcement-detail',
    path: '/user-owner-announcement-detail',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserOwnerAnnouncementRoute =
  BusinessLayoutUserOwnerAnnouncementImport.update({
    id: '/user-owner-announcement',
    path: '/user-owner-announcement',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserEmployeeManagementRoute =
  BusinessLayoutUserEmployeeManagementImport.update({
    id: '/user-employee-management',
    path: '/user-employee-management',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserEmployeeDetailRoute =
  BusinessLayoutUserEmployeeDetailImport.update({
    id: '/user-employee-detail',
    path: '/user-employee-detail',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserCustomerManagementDetailRoute =
  BusinessLayoutUserCustomerManagementDetailImport.update({
    id: '/user-customer-management-detail',
    path: '/user-customer-management-detail',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserCustomerManagementRoute =
  BusinessLayoutUserCustomerManagementImport.update({
    id: '/user-customer-management',
    path: '/user-customer-management',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserCustomerInfoRoute =
  BusinessLayoutUserCustomerInfoImport.update({
    id: '/user-customer-info',
    path: '/user-customer-info',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserCreditWalletChargeSuccessRoute =
  BusinessLayoutUserCreditWalletChargeSuccessImport.update({
    id: '/user-credit-wallet-charge-success',
    path: '/user-credit-wallet-charge-success',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserCreditWalletChargeFailRoute =
  BusinessLayoutUserCreditWalletChargeFailImport.update({
    id: '/user-credit-wallet-charge-fail',
    path: '/user-credit-wallet-charge-fail',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserCreditWalletChargeRoute =
  BusinessLayoutUserCreditWalletChargeImport.update({
    id: '/user-credit-wallet-charge',
    path: '/user-credit-wallet-charge',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserCreditWalletRoute =
  BusinessLayoutUserCreditWalletImport.update({
    id: '/user-credit-wallet',
    path: '/user-credit-wallet',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserContractManagementOldRoute =
  BusinessLayoutUserContractManagementOldImport.update({
    id: '/user-contract-managementOld',
    path: '/user-contract-managementOld',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserContractManagementRoute =
  BusinessLayoutUserContractManagementImport.update({
    id: '/user-contract-management',
    path: '/user-contract-management',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserContractDetailRoute =
  BusinessLayoutUserContractDetailImport.update({
    id: '/user-contract-detail',
    path: '/user-contract-detail',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserBusinessTimeManagementRoute =
  BusinessLayoutUserBusinessTimeManagementImport.update({
    id: '/user-business-time-management',
    path: '/user-business-time-management',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserBusinessPhotoManagementRoute =
  BusinessLayoutUserBusinessPhotoManagementImport.update({
    id: '/user-business-photo-management',
    path: '/user-business-photo-management',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserBusinessInfoRoute =
  BusinessLayoutUserBusinessInfoImport.update({
    id: '/user-business-info',
    path: '/user-business-info',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutUserRoute = BusinessLayoutUserImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutToSchoolRoute = BusinessLayoutToSchoolImport.update({
  id: '/to-school',
  path: '/to-school',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutTeacherRoute = BusinessLayoutTeacherImport.update({
  id: '/teacher',
  path: '/teacher',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutSealManagementRoute =
  BusinessLayoutSealManagementImport.update({
    id: '/seal-management',
    path: '/seal-management',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutRevservationRoute = BusinessLayoutRevservationImport.update(
  {
    id: '/revservation',
    path: '/revservation',
    getParentRoute: () => BusinessLayoutRoute,
  } as any,
)

const BusinessLayoutReservationWithIssuedTicketRoute =
  BusinessLayoutReservationWithIssuedTicketImport.update({
    id: '/reservation-with-issued-ticket',
    path: '/reservation-with-issued-ticket',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutNotifyStyleRoute = BusinessLayoutNotifyStyleImport.update({
  id: '/notify-style',
  path: '/notify-style',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutNotifySendRoute = BusinessLayoutNotifySendImport.update({
  id: '/notify-send',
  path: '/notify-send',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutNotifySavedNotifyRoute =
  BusinessLayoutNotifySavedNotifyImport.update({
    id: '/notify-saved-notify',
    path: '/notify-saved-notify',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutNotifyDetailRoute = BusinessLayoutNotifyDetailImport.update(
  {
    id: '/notify-detail',
    path: '/notify-detail',
    getParentRoute: () => BusinessLayoutRoute,
  } as any,
)

const BusinessLayoutNotifyBatchRoute = BusinessLayoutNotifyBatchImport.update({
  id: '/notify-batch',
  path: '/notify-batch',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutNotifyRoute = BusinessLayoutNotifyImport.update({
  id: '/notify',
  path: '/notify',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutManualReserveRoute =
  BusinessLayoutManualReserveImport.update({
    id: '/manual-reserve',
    path: '/manual-reserve',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutHomeRoute = BusinessLayoutHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutGalleryAddRoute = BusinessLayoutGalleryAddImport.update({
  id: '/gallery-add',
  path: '/gallery-add',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutGalleryRoute = BusinessLayoutGalleryImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutContractTemplatesRoute =
  BusinessLayoutContractTemplatesImport.update({
    id: '/contract-templates',
    path: '/contract-templates',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutContractTemplateImportRoute =
  BusinessLayoutContractTemplateImportImport.update({
    id: '/contract-template-import',
    path: '/contract-template-import',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutContractTemplateEditRoute =
  BusinessLayoutContractTemplateEditImport.update({
    id: '/contract-template-edit',
    path: '/contract-template-edit',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutContractStatusRoute =
  BusinessLayoutContractStatusImport.update({
    id: '/contract-status',
    path: '/contract-status',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutContractRequestSendRoute =
  BusinessLayoutContractRequestSendImport.update({
    id: '/contract-request-send',
    path: '/contract-request-send',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutContractRequestDetailRoute =
  BusinessLayoutContractRequestDetailImport.update({
    id: '/contract-request-detail',
    path: '/contract-request-detail',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutCompanyPhotoAddRoute =
  BusinessLayoutCompanyPhotoAddImport.update({
    id: '/company-photo-add',
    path: '/company-photo-add',
    getParentRoute: () => BusinessLayoutRoute,
  } as any)

const BusinessLayoutCalendarRoute = BusinessLayoutCalendarImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const BusinessLayoutAboutRoute = BusinessLayoutAboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

const CustomerLayoutPaymentIndexRoute = CustomerLayoutPaymentIndexImport.update(
  {
    id: '/payment/',
    path: '/payment/',
    getParentRoute: () => CustomerLayoutRoute,
  } as any,
)

const CustomerLayoutPaymentSuccessRoute =
  CustomerLayoutPaymentSuccessImport.update({
    id: '/payment/success',
    path: '/payment/success',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutPaymentIndexcopyRoute =
  CustomerLayoutPaymentIndexcopyImport.update({
    id: '/payment/index copy',
    path: '/payment/index copy',
    getParentRoute: () => CustomerLayoutRoute,
  } as any)

const CustomerLayoutPaymentFailRoute = CustomerLayoutPaymentFailImport.update({
  id: '/payment/fail',
  path: '/payment/fail',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const CustomerLayoutPaymentAuthRoute = CustomerLayoutPaymentAuthImport.update({
  id: '/payment/auth',
  path: '/payment/auth',
  getParentRoute: () => CustomerLayoutRoute,
} as any)

const BusinessLayoutPaymentTestRoute = BusinessLayoutPaymentTestImport.update({
  id: '/payment/test',
  path: '/payment/test',
  getParentRoute: () => BusinessLayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/login-stage': {
      id: '/login-stage'
      path: '/login-stage'
      fullPath: '/login-stage'
      preLoaderRoute: typeof LoginStageImport
      parentRoute: typeof rootRoute
    }
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/auth/handoff': {
      id: '/auth/handoff'
      path: '/auth/handoff'
      fullPath: '/auth/handoff'
      preLoaderRoute: typeof AuthHandoffImport
      parentRoute: typeof rootRoute
    }
    '/business/layout': {
      id: '/business/layout'
      path: '/business/layout'
      fullPath: '/business/layout'
      preLoaderRoute: typeof BusinessLayoutImport
      parentRoute: typeof rootRoute
    }
    '/customer/alert': {
      id: '/customer/alert'
      path: '/customer/alert'
      fullPath: '/customer/alert'
      preLoaderRoute: typeof CustomerAlertImport
      parentRoute: typeof rootRoute
    }
    '/customer/layout': {
      id: '/customer/layout'
      path: '/customer/layout'
      fullPath: '/customer/layout'
      preLoaderRoute: typeof CustomerLayoutImport
      parentRoute: typeof rootRoute
    }
    '/oauth/google': {
      id: '/oauth/google'
      path: '/oauth/google'
      fullPath: '/oauth/google'
      preLoaderRoute: typeof OauthGoogleImport
      parentRoute: typeof rootRoute
    }
    '/oauth/kakao': {
      id: '/oauth/kakao'
      path: '/oauth/kakao'
      fullPath: '/oauth/kakao'
      preLoaderRoute: typeof OauthKakaoImport
      parentRoute: typeof rootRoute
    }
    '/oauth/naver': {
      id: '/oauth/naver'
      path: '/oauth/naver'
      fullPath: '/oauth/naver'
      preLoaderRoute: typeof OauthNaverImport
      parentRoute: typeof rootRoute
    }
    '/sign-up/business-owner': {
      id: '/sign-up/business-owner'
      path: '/business-owner'
      fullPath: '/sign-up/business-owner'
      preLoaderRoute: typeof SignUpBusinessOwnerImport
      parentRoute: typeof SignUpImport
    }
    '/sign-up/business-owner-detail': {
      id: '/sign-up/business-owner-detail'
      path: '/business-owner-detail'
      fullPath: '/sign-up/business-owner-detail'
      preLoaderRoute: typeof SignUpBusinessOwnerDetailImport
      parentRoute: typeof SignUpImport
    }
    '/sign-up/business-owner-done': {
      id: '/sign-up/business-owner-done'
      path: '/business-owner-done'
      fullPath: '/sign-up/business-owner-done'
      preLoaderRoute: typeof SignUpBusinessOwnerDoneImport
      parentRoute: typeof SignUpImport
    }
    '/sign-up/business-teacher': {
      id: '/sign-up/business-teacher'
      path: '/business-teacher'
      fullPath: '/sign-up/business-teacher'
      preLoaderRoute: typeof SignUpBusinessTeacherImport
      parentRoute: typeof SignUpImport
    }
    '/sign-up/business-teacher-done': {
      id: '/sign-up/business-teacher-done'
      path: '/business-teacher-done'
      fullPath: '/sign-up/business-teacher-done'
      preLoaderRoute: typeof SignUpBusinessTeacherDoneImport
      parentRoute: typeof SignUpImport
    }
    '/sign-up/customer': {
      id: '/sign-up/customer'
      path: '/customer'
      fullPath: '/sign-up/customer'
      preLoaderRoute: typeof SignUpCustomerImport
      parentRoute: typeof SignUpImport
    }
    '/sign-up/customer-done': {
      id: '/sign-up/customer-done'
      path: '/customer-done'
      fullPath: '/sign-up/customer-done'
      preLoaderRoute: typeof SignUpCustomerDoneImport
      parentRoute: typeof SignUpImport
    }
    '/sign-up/pet': {
      id: '/sign-up/pet'
      path: '/pet'
      fullPath: '/sign-up/pet'
      preLoaderRoute: typeof SignUpPetImport
      parentRoute: typeof SignUpImport
    }
    '/sign-up/': {
      id: '/sign-up/'
      path: '/'
      fullPath: '/sign-up/'
      preLoaderRoute: typeof SignUpIndexImport
      parentRoute: typeof SignUpImport
    }
    '/business/layout/about': {
      id: '/business/layout/about'
      path: '/about'
      fullPath: '/business/layout/about'
      preLoaderRoute: typeof BusinessLayoutAboutImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/calendar': {
      id: '/business/layout/calendar'
      path: '/calendar'
      fullPath: '/business/layout/calendar'
      preLoaderRoute: typeof BusinessLayoutCalendarImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/company-photo-add': {
      id: '/business/layout/company-photo-add'
      path: '/company-photo-add'
      fullPath: '/business/layout/company-photo-add'
      preLoaderRoute: typeof BusinessLayoutCompanyPhotoAddImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/contract-request-detail': {
      id: '/business/layout/contract-request-detail'
      path: '/contract-request-detail'
      fullPath: '/business/layout/contract-request-detail'
      preLoaderRoute: typeof BusinessLayoutContractRequestDetailImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/contract-request-send': {
      id: '/business/layout/contract-request-send'
      path: '/contract-request-send'
      fullPath: '/business/layout/contract-request-send'
      preLoaderRoute: typeof BusinessLayoutContractRequestSendImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/contract-status': {
      id: '/business/layout/contract-status'
      path: '/contract-status'
      fullPath: '/business/layout/contract-status'
      preLoaderRoute: typeof BusinessLayoutContractStatusImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/contract-template-edit': {
      id: '/business/layout/contract-template-edit'
      path: '/contract-template-edit'
      fullPath: '/business/layout/contract-template-edit'
      preLoaderRoute: typeof BusinessLayoutContractTemplateEditImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/contract-template-import': {
      id: '/business/layout/contract-template-import'
      path: '/contract-template-import'
      fullPath: '/business/layout/contract-template-import'
      preLoaderRoute: typeof BusinessLayoutContractTemplateImportImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/contract-templates': {
      id: '/business/layout/contract-templates'
      path: '/contract-templates'
      fullPath: '/business/layout/contract-templates'
      preLoaderRoute: typeof BusinessLayoutContractTemplatesImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/gallery': {
      id: '/business/layout/gallery'
      path: '/gallery'
      fullPath: '/business/layout/gallery'
      preLoaderRoute: typeof BusinessLayoutGalleryImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/gallery-add': {
      id: '/business/layout/gallery-add'
      path: '/gallery-add'
      fullPath: '/business/layout/gallery-add'
      preLoaderRoute: typeof BusinessLayoutGalleryAddImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/home': {
      id: '/business/layout/home'
      path: '/home'
      fullPath: '/business/layout/home'
      preLoaderRoute: typeof BusinessLayoutHomeImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/manual-reserve': {
      id: '/business/layout/manual-reserve'
      path: '/manual-reserve'
      fullPath: '/business/layout/manual-reserve'
      preLoaderRoute: typeof BusinessLayoutManualReserveImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/notify': {
      id: '/business/layout/notify'
      path: '/notify'
      fullPath: '/business/layout/notify'
      preLoaderRoute: typeof BusinessLayoutNotifyImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/notify-batch': {
      id: '/business/layout/notify-batch'
      path: '/notify-batch'
      fullPath: '/business/layout/notify-batch'
      preLoaderRoute: typeof BusinessLayoutNotifyBatchImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/notify-detail': {
      id: '/business/layout/notify-detail'
      path: '/notify-detail'
      fullPath: '/business/layout/notify-detail'
      preLoaderRoute: typeof BusinessLayoutNotifyDetailImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/notify-saved-notify': {
      id: '/business/layout/notify-saved-notify'
      path: '/notify-saved-notify'
      fullPath: '/business/layout/notify-saved-notify'
      preLoaderRoute: typeof BusinessLayoutNotifySavedNotifyImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/notify-send': {
      id: '/business/layout/notify-send'
      path: '/notify-send'
      fullPath: '/business/layout/notify-send'
      preLoaderRoute: typeof BusinessLayoutNotifySendImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/notify-style': {
      id: '/business/layout/notify-style'
      path: '/notify-style'
      fullPath: '/business/layout/notify-style'
      preLoaderRoute: typeof BusinessLayoutNotifyStyleImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/reservation-with-issued-ticket': {
      id: '/business/layout/reservation-with-issued-ticket'
      path: '/reservation-with-issued-ticket'
      fullPath: '/business/layout/reservation-with-issued-ticket'
      preLoaderRoute: typeof BusinessLayoutReservationWithIssuedTicketImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/revservation': {
      id: '/business/layout/revservation'
      path: '/revservation'
      fullPath: '/business/layout/revservation'
      preLoaderRoute: typeof BusinessLayoutRevservationImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/seal-management': {
      id: '/business/layout/seal-management'
      path: '/seal-management'
      fullPath: '/business/layout/seal-management'
      preLoaderRoute: typeof BusinessLayoutSealManagementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/teacher': {
      id: '/business/layout/teacher'
      path: '/teacher'
      fullPath: '/business/layout/teacher'
      preLoaderRoute: typeof BusinessLayoutTeacherImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/to-school': {
      id: '/business/layout/to-school'
      path: '/to-school'
      fullPath: '/business/layout/to-school'
      preLoaderRoute: typeof BusinessLayoutToSchoolImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user': {
      id: '/business/layout/user'
      path: '/user'
      fullPath: '/business/layout/user'
      preLoaderRoute: typeof BusinessLayoutUserImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-business-info': {
      id: '/business/layout/user-business-info'
      path: '/user-business-info'
      fullPath: '/business/layout/user-business-info'
      preLoaderRoute: typeof BusinessLayoutUserBusinessInfoImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-business-photo-management': {
      id: '/business/layout/user-business-photo-management'
      path: '/user-business-photo-management'
      fullPath: '/business/layout/user-business-photo-management'
      preLoaderRoute: typeof BusinessLayoutUserBusinessPhotoManagementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-business-time-management': {
      id: '/business/layout/user-business-time-management'
      path: '/user-business-time-management'
      fullPath: '/business/layout/user-business-time-management'
      preLoaderRoute: typeof BusinessLayoutUserBusinessTimeManagementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-contract-detail': {
      id: '/business/layout/user-contract-detail'
      path: '/user-contract-detail'
      fullPath: '/business/layout/user-contract-detail'
      preLoaderRoute: typeof BusinessLayoutUserContractDetailImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-contract-management': {
      id: '/business/layout/user-contract-management'
      path: '/user-contract-management'
      fullPath: '/business/layout/user-contract-management'
      preLoaderRoute: typeof BusinessLayoutUserContractManagementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-contract-managementOld': {
      id: '/business/layout/user-contract-managementOld'
      path: '/user-contract-managementOld'
      fullPath: '/business/layout/user-contract-managementOld'
      preLoaderRoute: typeof BusinessLayoutUserContractManagementOldImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-credit-wallet': {
      id: '/business/layout/user-credit-wallet'
      path: '/user-credit-wallet'
      fullPath: '/business/layout/user-credit-wallet'
      preLoaderRoute: typeof BusinessLayoutUserCreditWalletImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-credit-wallet-charge': {
      id: '/business/layout/user-credit-wallet-charge'
      path: '/user-credit-wallet-charge'
      fullPath: '/business/layout/user-credit-wallet-charge'
      preLoaderRoute: typeof BusinessLayoutUserCreditWalletChargeImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-credit-wallet-charge-fail': {
      id: '/business/layout/user-credit-wallet-charge-fail'
      path: '/user-credit-wallet-charge-fail'
      fullPath: '/business/layout/user-credit-wallet-charge-fail'
      preLoaderRoute: typeof BusinessLayoutUserCreditWalletChargeFailImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-credit-wallet-charge-success': {
      id: '/business/layout/user-credit-wallet-charge-success'
      path: '/user-credit-wallet-charge-success'
      fullPath: '/business/layout/user-credit-wallet-charge-success'
      preLoaderRoute: typeof BusinessLayoutUserCreditWalletChargeSuccessImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-customer-info': {
      id: '/business/layout/user-customer-info'
      path: '/user-customer-info'
      fullPath: '/business/layout/user-customer-info'
      preLoaderRoute: typeof BusinessLayoutUserCustomerInfoImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-customer-management': {
      id: '/business/layout/user-customer-management'
      path: '/user-customer-management'
      fullPath: '/business/layout/user-customer-management'
      preLoaderRoute: typeof BusinessLayoutUserCustomerManagementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-customer-management-detail': {
      id: '/business/layout/user-customer-management-detail'
      path: '/user-customer-management-detail'
      fullPath: '/business/layout/user-customer-management-detail'
      preLoaderRoute: typeof BusinessLayoutUserCustomerManagementDetailImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-employee-detail': {
      id: '/business/layout/user-employee-detail'
      path: '/user-employee-detail'
      fullPath: '/business/layout/user-employee-detail'
      preLoaderRoute: typeof BusinessLayoutUserEmployeeDetailImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-employee-management': {
      id: '/business/layout/user-employee-management'
      path: '/user-employee-management'
      fullPath: '/business/layout/user-employee-management'
      preLoaderRoute: typeof BusinessLayoutUserEmployeeManagementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-owner-announcement': {
      id: '/business/layout/user-owner-announcement'
      path: '/user-owner-announcement'
      fullPath: '/business/layout/user-owner-announcement'
      preLoaderRoute: typeof BusinessLayoutUserOwnerAnnouncementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-owner-announcement-detail': {
      id: '/business/layout/user-owner-announcement-detail'
      path: '/user-owner-announcement-detail'
      fullPath: '/business/layout/user-owner-announcement-detail'
      preLoaderRoute: typeof BusinessLayoutUserOwnerAnnouncementDetailImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-owner-info': {
      id: '/business/layout/user-owner-info'
      path: '/user-owner-info'
      fullPath: '/business/layout/user-owner-info'
      preLoaderRoute: typeof BusinessLayoutUserOwnerInfoImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-owner-push': {
      id: '/business/layout/user-owner-push'
      path: '/user-owner-push'
      fullPath: '/business/layout/user-owner-push'
      preLoaderRoute: typeof BusinessLayoutUserOwnerPushImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-owner-setting': {
      id: '/business/layout/user-owner-setting'
      path: '/user-owner-setting'
      fullPath: '/business/layout/user-owner-setting'
      preLoaderRoute: typeof BusinessLayoutUserOwnerSettingImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-payment-history': {
      id: '/business/layout/user-payment-history'
      path: '/user-payment-history'
      fullPath: '/business/layout/user-payment-history'
      preLoaderRoute: typeof BusinessLayoutUserPaymentHistoryImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-product-management': {
      id: '/business/layout/user-product-management'
      path: '/user-product-management'
      fullPath: '/business/layout/user-product-management'
      preLoaderRoute: typeof BusinessLayoutUserProductManagementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-service-statistics': {
      id: '/business/layout/user-service-statistics'
      path: '/user-service-statistics'
      fullPath: '/business/layout/user-service-statistics'
      preLoaderRoute: typeof BusinessLayoutUserServiceStatisticsImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-subscription-add-edit': {
      id: '/business/layout/user-subscription-add-edit'
      path: '/user-subscription-add-edit'
      fullPath: '/business/layout/user-subscription-add-edit'
      preLoaderRoute: typeof BusinessLayoutUserSubscriptionAddEditImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-subscription-issue': {
      id: '/business/layout/user-subscription-issue'
      path: '/user-subscription-issue'
      fullPath: '/business/layout/user-subscription-issue'
      preLoaderRoute: typeof BusinessLayoutUserSubscriptionIssueImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-subscription-issue-detail': {
      id: '/business/layout/user-subscription-issue-detail'
      path: '/user-subscription-issue-detail'
      fullPath: '/business/layout/user-subscription-issue-detail'
      preLoaderRoute: typeof BusinessLayoutUserSubscriptionIssueDetailImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-subscription-issue-history': {
      id: '/business/layout/user-subscription-issue-history'
      path: '/user-subscription-issue-history'
      fullPath: '/business/layout/user-subscription-issue-history'
      preLoaderRoute: typeof BusinessLayoutUserSubscriptionIssueHistoryImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-subscription-management': {
      id: '/business/layout/user-subscription-management'
      path: '/user-subscription-management'
      fullPath: '/business/layout/user-subscription-management'
      preLoaderRoute: typeof BusinessLayoutUserSubscriptionManagementImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-subscription-order-edit': {
      id: '/business/layout/user-subscription-order-edit'
      path: '/user-subscription-order-edit'
      fullPath: '/business/layout/user-subscription-order-edit'
      preLoaderRoute: typeof BusinessLayoutUserSubscriptionOrderEditImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-teacher-info': {
      id: '/business/layout/user-teacher-info'
      path: '/user-teacher-info'
      fullPath: '/business/layout/user-teacher-info'
      preLoaderRoute: typeof BusinessLayoutUserTeacherInfoImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-teacher-push': {
      id: '/business/layout/user-teacher-push'
      path: '/user-teacher-push'
      fullPath: '/business/layout/user-teacher-push'
      preLoaderRoute: typeof BusinessLayoutUserTeacherPushImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/business/layout/user-teacher-setting': {
      id: '/business/layout/user-teacher-setting'
      path: '/user-teacher-setting'
      fullPath: '/business/layout/user-teacher-setting'
      preLoaderRoute: typeof BusinessLayoutUserTeacherSettingImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/customer/layout/about': {
      id: '/customer/layout/about'
      path: '/about'
      fullPath: '/customer/layout/about'
      preLoaderRoute: typeof CustomerLayoutAboutImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/calendar': {
      id: '/customer/layout/calendar'
      path: '/calendar'
      fullPath: '/customer/layout/calendar'
      preLoaderRoute: typeof CustomerLayoutCalendarImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/calendar-reservation': {
      id: '/customer/layout/calendar-reservation'
      path: '/calendar-reservation'
      fullPath: '/customer/layout/calendar-reservation'
      preLoaderRoute: typeof CustomerLayoutCalendarReservationImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/calendar-reservation-chg': {
      id: '/customer/layout/calendar-reservation-chg'
      path: '/calendar-reservation-chg'
      fullPath: '/customer/layout/calendar-reservation-chg'
      preLoaderRoute: typeof CustomerLayoutCalendarReservationChgImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/contract-inbox': {
      id: '/customer/layout/contract-inbox'
      path: '/contract-inbox'
      fullPath: '/customer/layout/contract-inbox'
      preLoaderRoute: typeof CustomerLayoutContractInboxImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/contract-sign': {
      id: '/customer/layout/contract-sign'
      path: '/contract-sign'
      fullPath: '/customer/layout/contract-sign'
      preLoaderRoute: typeof CustomerLayoutContractSignImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/gallery': {
      id: '/customer/layout/gallery'
      path: '/gallery'
      fullPath: '/customer/layout/gallery'
      preLoaderRoute: typeof CustomerLayoutGalleryImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/gallery-detail': {
      id: '/customer/layout/gallery-detail'
      path: '/gallery-detail'
      fullPath: '/customer/layout/gallery-detail'
      preLoaderRoute: typeof CustomerLayoutGalleryDetailImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/home': {
      id: '/customer/layout/home'
      path: '/home'
      fullPath: '/customer/layout/home'
      preLoaderRoute: typeof CustomerLayoutHomeImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/home-alert': {
      id: '/customer/layout/home-alert'
      path: '/home-alert'
      fullPath: '/customer/layout/home-alert'
      preLoaderRoute: typeof CustomerLayoutHomeAlertImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/home-serach-detail': {
      id: '/customer/layout/home-serach-detail'
      path: '/home-serach-detail'
      fullPath: '/customer/layout/home-serach-detail'
      preLoaderRoute: typeof CustomerLayoutHomeSerachDetailImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/home-serach-store': {
      id: '/customer/layout/home-serach-store'
      path: '/home-serach-store'
      fullPath: '/customer/layout/home-serach-store'
      preLoaderRoute: typeof CustomerLayoutHomeSerachStoreImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/info-suggest': {
      id: '/customer/layout/info-suggest'
      path: '/info-suggest'
      fullPath: '/customer/layout/info-suggest'
      preLoaderRoute: typeof CustomerLayoutInfoSuggestImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/inform': {
      id: '/customer/layout/inform'
      path: '/inform'
      fullPath: '/customer/layout/inform'
      preLoaderRoute: typeof CustomerLayoutInformImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/inform-detail': {
      id: '/customer/layout/inform-detail'
      path: '/inform-detail'
      fullPath: '/customer/layout/inform-detail'
      preLoaderRoute: typeof CustomerLayoutInformDetailImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/inform-send': {
      id: '/customer/layout/inform-send'
      path: '/inform-send'
      fullPath: '/customer/layout/inform-send'
      preLoaderRoute: typeof CustomerLayoutInformSendImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/inform-send-fix': {
      id: '/customer/layout/inform-send-fix'
      path: '/inform-send-fix'
      fullPath: '/customer/layout/inform-send-fix'
      preLoaderRoute: typeof CustomerLayoutInformSendFixImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/inquiry-history': {
      id: '/customer/layout/inquiry-history'
      path: '/inquiry-history'
      fullPath: '/customer/layout/inquiry-history'
      preLoaderRoute: typeof CustomerLayoutInquiryHistoryImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/map': {
      id: '/customer/layout/map'
      path: '/map'
      fullPath: '/customer/layout/map'
      preLoaderRoute: typeof CustomerLayoutMapImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/map-list': {
      id: '/customer/layout/map-list'
      path: '/map-list'
      fullPath: '/customer/layout/map-list'
      preLoaderRoute: typeof CustomerLayoutMapListImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/member-code': {
      id: '/customer/layout/member-code'
      path: '/member-code'
      fullPath: '/customer/layout/member-code'
      preLoaderRoute: typeof CustomerLayoutMemberCodeImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/reservation': {
      id: '/customer/layout/reservation'
      path: '/reservation'
      fullPath: '/customer/layout/reservation'
      preLoaderRoute: typeof CustomerLayoutReservationImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/reservation-with-subscription': {
      id: '/customer/layout/reservation-with-subscription'
      path: '/reservation-with-subscription'
      fullPath: '/customer/layout/reservation-with-subscription'
      preLoaderRoute: typeof CustomerLayoutReservationWithSubscriptionImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/search': {
      id: '/customer/layout/search'
      path: '/search'
      fullPath: '/customer/layout/search'
      preLoaderRoute: typeof CustomerLayoutSearchImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/subscription-list': {
      id: '/customer/layout/subscription-list'
      path: '/subscription-list'
      fullPath: '/customer/layout/subscription-list'
      preLoaderRoute: typeof CustomerLayoutSubscriptionListImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/to-school': {
      id: '/customer/layout/to-school'
      path: '/to-school'
      fullPath: '/customer/layout/to-school'
      preLoaderRoute: typeof CustomerLayoutToSchoolImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user': {
      id: '/customer/layout/user'
      path: '/user'
      fullPath: '/customer/layout/user'
      preLoaderRoute: typeof CustomerLayoutUserImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-announcement': {
      id: '/customer/layout/user-announcement'
      path: '/user-announcement'
      fullPath: '/customer/layout/user-announcement'
      preLoaderRoute: typeof CustomerLayoutUserAnnouncementImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-announcement-detail': {
      id: '/customer/layout/user-announcement-detail'
      path: '/user-announcement-detail'
      fullPath: '/customer/layout/user-announcement-detail'
      preLoaderRoute: typeof CustomerLayoutUserAnnouncementDetailImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-buy-coin': {
      id: '/customer/layout/user-buy-coin'
      path: '/user-buy-coin'
      fullPath: '/customer/layout/user-buy-coin'
      preLoaderRoute: typeof CustomerLayoutUserBuyCoinImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-contract': {
      id: '/customer/layout/user-contract'
      path: '/user-contract'
      fullPath: '/customer/layout/user-contract'
      preLoaderRoute: typeof CustomerLayoutUserContractImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-contract-detail': {
      id: '/customer/layout/user-contract-detail'
      path: '/user-contract-detail'
      fullPath: '/customer/layout/user-contract-detail'
      preLoaderRoute: typeof CustomerLayoutUserContractDetailImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-guardian-link': {
      id: '/customer/layout/user-guardian-link'
      path: '/user-guardian-link'
      fullPath: '/customer/layout/user-guardian-link'
      preLoaderRoute: typeof CustomerLayoutUserGuardianLinkImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-info-Chg': {
      id: '/customer/layout/user-info-Chg'
      path: '/user-info-Chg'
      fullPath: '/customer/layout/user-info-Chg'
      preLoaderRoute: typeof CustomerLayoutUserInfoChgImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-pet-info': {
      id: '/customer/layout/user-pet-info'
      path: '/user-pet-info'
      fullPath: '/customer/layout/user-pet-info'
      preLoaderRoute: typeof CustomerLayoutUserPetInfoImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-pet-info-add': {
      id: '/customer/layout/user-pet-info-add'
      path: '/user-pet-info-add'
      fullPath: '/customer/layout/user-pet-info-add'
      preLoaderRoute: typeof CustomerLayoutUserPetInfoAddImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-pet-info-chg': {
      id: '/customer/layout/user-pet-info-chg'
      path: '/user-pet-info-chg'
      fullPath: '/customer/layout/user-pet-info-chg'
      preLoaderRoute: typeof CustomerLayoutUserPetInfoChgImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-push': {
      id: '/customer/layout/user-push'
      path: '/user-push'
      fullPath: '/customer/layout/user-push'
      preLoaderRoute: typeof CustomerLayoutUserPushImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-subscription-detail': {
      id: '/customer/layout/user-subscription-detail'
      path: '/user-subscription-detail'
      fullPath: '/customer/layout/user-subscription-detail'
      preLoaderRoute: typeof CustomerLayoutUserSubscriptionDetailImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-subscriptions': {
      id: '/customer/layout/user-subscriptions'
      path: '/user-subscriptions'
      fullPath: '/customer/layout/user-subscriptions'
      preLoaderRoute: typeof CustomerLayoutUserSubscriptionsImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-usage-history': {
      id: '/customer/layout/user-usage-history'
      path: '/user-usage-history'
      fullPath: '/customer/layout/user-usage-history'
      preLoaderRoute: typeof CustomerLayoutUserUsageHistoryImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/user-usage-history-detail': {
      id: '/customer/layout/user-usage-history-detail'
      path: '/user-usage-history-detail'
      fullPath: '/customer/layout/user-usage-history-detail'
      preLoaderRoute: typeof CustomerLayoutUserUsageHistoryDetailImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/oauth/google/callback': {
      id: '/oauth/google/callback'
      path: '/callback'
      fullPath: '/oauth/google/callback'
      preLoaderRoute: typeof OauthGoogleCallbackImport
      parentRoute: typeof OauthGoogleImport
    }
    '/business/layout/test': {
      id: '/business/layout/test'
      path: '/test'
      fullPath: '/business/layout/test'
      preLoaderRoute: typeof BusinessLayoutTestLazyImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/customer/layout/test': {
      id: '/customer/layout/test'
      path: '/test'
      fullPath: '/customer/layout/test'
      preLoaderRoute: typeof CustomerLayoutTestLazyImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/business/layout/payment/test': {
      id: '/business/layout/payment/test'
      path: '/payment/test'
      fullPath: '/business/layout/payment/test'
      preLoaderRoute: typeof BusinessLayoutPaymentTestImport
      parentRoute: typeof BusinessLayoutImport
    }
    '/customer/layout/payment/auth': {
      id: '/customer/layout/payment/auth'
      path: '/payment/auth'
      fullPath: '/customer/layout/payment/auth'
      preLoaderRoute: typeof CustomerLayoutPaymentAuthImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/payment/fail': {
      id: '/customer/layout/payment/fail'
      path: '/payment/fail'
      fullPath: '/customer/layout/payment/fail'
      preLoaderRoute: typeof CustomerLayoutPaymentFailImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/payment/index copy': {
      id: '/customer/layout/payment/index copy'
      path: '/payment/index copy'
      fullPath: '/customer/layout/payment/index copy'
      preLoaderRoute: typeof CustomerLayoutPaymentIndexcopyImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/payment/success': {
      id: '/customer/layout/payment/success'
      path: '/payment/success'
      fullPath: '/customer/layout/payment/success'
      preLoaderRoute: typeof CustomerLayoutPaymentSuccessImport
      parentRoute: typeof CustomerLayoutImport
    }
    '/customer/layout/payment/': {
      id: '/customer/layout/payment/'
      path: '/payment'
      fullPath: '/customer/layout/payment'
      preLoaderRoute: typeof CustomerLayoutPaymentIndexImport
      parentRoute: typeof CustomerLayoutImport
    }
  }
}

// Create and export the route tree

interface SignUpRouteChildren {
  SignUpBusinessOwnerRoute: typeof SignUpBusinessOwnerRoute
  SignUpBusinessOwnerDetailRoute: typeof SignUpBusinessOwnerDetailRoute
  SignUpBusinessOwnerDoneRoute: typeof SignUpBusinessOwnerDoneRoute
  SignUpBusinessTeacherRoute: typeof SignUpBusinessTeacherRoute
  SignUpBusinessTeacherDoneRoute: typeof SignUpBusinessTeacherDoneRoute
  SignUpCustomerRoute: typeof SignUpCustomerRoute
  SignUpCustomerDoneRoute: typeof SignUpCustomerDoneRoute
  SignUpPetRoute: typeof SignUpPetRoute
  SignUpIndexRoute: typeof SignUpIndexRoute
}

const SignUpRouteChildren: SignUpRouteChildren = {
  SignUpBusinessOwnerRoute: SignUpBusinessOwnerRoute,
  SignUpBusinessOwnerDetailRoute: SignUpBusinessOwnerDetailRoute,
  SignUpBusinessOwnerDoneRoute: SignUpBusinessOwnerDoneRoute,
  SignUpBusinessTeacherRoute: SignUpBusinessTeacherRoute,
  SignUpBusinessTeacherDoneRoute: SignUpBusinessTeacherDoneRoute,
  SignUpCustomerRoute: SignUpCustomerRoute,
  SignUpCustomerDoneRoute: SignUpCustomerDoneRoute,
  SignUpPetRoute: SignUpPetRoute,
  SignUpIndexRoute: SignUpIndexRoute,
}

const SignUpRouteWithChildren =
  SignUpRoute._addFileChildren(SignUpRouteChildren)

interface BusinessLayoutRouteChildren {
  BusinessLayoutAboutRoute: typeof BusinessLayoutAboutRoute
  BusinessLayoutCalendarRoute: typeof BusinessLayoutCalendarRoute
  BusinessLayoutCompanyPhotoAddRoute: typeof BusinessLayoutCompanyPhotoAddRoute
  BusinessLayoutContractRequestDetailRoute: typeof BusinessLayoutContractRequestDetailRoute
  BusinessLayoutContractRequestSendRoute: typeof BusinessLayoutContractRequestSendRoute
  BusinessLayoutContractStatusRoute: typeof BusinessLayoutContractStatusRoute
  BusinessLayoutContractTemplateEditRoute: typeof BusinessLayoutContractTemplateEditRoute
  BusinessLayoutContractTemplateImportRoute: typeof BusinessLayoutContractTemplateImportRoute
  BusinessLayoutContractTemplatesRoute: typeof BusinessLayoutContractTemplatesRoute
  BusinessLayoutGalleryRoute: typeof BusinessLayoutGalleryRoute
  BusinessLayoutGalleryAddRoute: typeof BusinessLayoutGalleryAddRoute
  BusinessLayoutHomeRoute: typeof BusinessLayoutHomeRoute
  BusinessLayoutManualReserveRoute: typeof BusinessLayoutManualReserveRoute
  BusinessLayoutNotifyRoute: typeof BusinessLayoutNotifyRoute
  BusinessLayoutNotifyBatchRoute: typeof BusinessLayoutNotifyBatchRoute
  BusinessLayoutNotifyDetailRoute: typeof BusinessLayoutNotifyDetailRoute
  BusinessLayoutNotifySavedNotifyRoute: typeof BusinessLayoutNotifySavedNotifyRoute
  BusinessLayoutNotifySendRoute: typeof BusinessLayoutNotifySendRoute
  BusinessLayoutNotifyStyleRoute: typeof BusinessLayoutNotifyStyleRoute
  BusinessLayoutReservationWithIssuedTicketRoute: typeof BusinessLayoutReservationWithIssuedTicketRoute
  BusinessLayoutRevservationRoute: typeof BusinessLayoutRevservationRoute
  BusinessLayoutSealManagementRoute: typeof BusinessLayoutSealManagementRoute
  BusinessLayoutTeacherRoute: typeof BusinessLayoutTeacherRoute
  BusinessLayoutToSchoolRoute: typeof BusinessLayoutToSchoolRoute
  BusinessLayoutUserRoute: typeof BusinessLayoutUserRoute
  BusinessLayoutUserBusinessInfoRoute: typeof BusinessLayoutUserBusinessInfoRoute
  BusinessLayoutUserBusinessPhotoManagementRoute: typeof BusinessLayoutUserBusinessPhotoManagementRoute
  BusinessLayoutUserBusinessTimeManagementRoute: typeof BusinessLayoutUserBusinessTimeManagementRoute
  BusinessLayoutUserContractDetailRoute: typeof BusinessLayoutUserContractDetailRoute
  BusinessLayoutUserContractManagementRoute: typeof BusinessLayoutUserContractManagementRoute
  BusinessLayoutUserContractManagementOldRoute: typeof BusinessLayoutUserContractManagementOldRoute
  BusinessLayoutUserCreditWalletRoute: typeof BusinessLayoutUserCreditWalletRoute
  BusinessLayoutUserCreditWalletChargeRoute: typeof BusinessLayoutUserCreditWalletChargeRoute
  BusinessLayoutUserCreditWalletChargeFailRoute: typeof BusinessLayoutUserCreditWalletChargeFailRoute
  BusinessLayoutUserCreditWalletChargeSuccessRoute: typeof BusinessLayoutUserCreditWalletChargeSuccessRoute
  BusinessLayoutUserCustomerInfoRoute: typeof BusinessLayoutUserCustomerInfoRoute
  BusinessLayoutUserCustomerManagementRoute: typeof BusinessLayoutUserCustomerManagementRoute
  BusinessLayoutUserCustomerManagementDetailRoute: typeof BusinessLayoutUserCustomerManagementDetailRoute
  BusinessLayoutUserEmployeeDetailRoute: typeof BusinessLayoutUserEmployeeDetailRoute
  BusinessLayoutUserEmployeeManagementRoute: typeof BusinessLayoutUserEmployeeManagementRoute
  BusinessLayoutUserOwnerAnnouncementRoute: typeof BusinessLayoutUserOwnerAnnouncementRoute
  BusinessLayoutUserOwnerAnnouncementDetailRoute: typeof BusinessLayoutUserOwnerAnnouncementDetailRoute
  BusinessLayoutUserOwnerInfoRoute: typeof BusinessLayoutUserOwnerInfoRoute
  BusinessLayoutUserOwnerPushRoute: typeof BusinessLayoutUserOwnerPushRoute
  BusinessLayoutUserOwnerSettingRoute: typeof BusinessLayoutUserOwnerSettingRoute
  BusinessLayoutUserPaymentHistoryRoute: typeof BusinessLayoutUserPaymentHistoryRoute
  BusinessLayoutUserProductManagementRoute: typeof BusinessLayoutUserProductManagementRoute
  BusinessLayoutUserServiceStatisticsRoute: typeof BusinessLayoutUserServiceStatisticsRoute
  BusinessLayoutUserSubscriptionAddEditRoute: typeof BusinessLayoutUserSubscriptionAddEditRoute
  BusinessLayoutUserSubscriptionIssueRoute: typeof BusinessLayoutUserSubscriptionIssueRoute
  BusinessLayoutUserSubscriptionIssueDetailRoute: typeof BusinessLayoutUserSubscriptionIssueDetailRoute
  BusinessLayoutUserSubscriptionIssueHistoryRoute: typeof BusinessLayoutUserSubscriptionIssueHistoryRoute
  BusinessLayoutUserSubscriptionManagementRoute: typeof BusinessLayoutUserSubscriptionManagementRoute
  BusinessLayoutUserSubscriptionOrderEditRoute: typeof BusinessLayoutUserSubscriptionOrderEditRoute
  BusinessLayoutUserTeacherInfoRoute: typeof BusinessLayoutUserTeacherInfoRoute
  BusinessLayoutUserTeacherPushRoute: typeof BusinessLayoutUserTeacherPushRoute
  BusinessLayoutUserTeacherSettingRoute: typeof BusinessLayoutUserTeacherSettingRoute
  BusinessLayoutTestLazyRoute: typeof BusinessLayoutTestLazyRoute
  BusinessLayoutPaymentTestRoute: typeof BusinessLayoutPaymentTestRoute
}

const BusinessLayoutRouteChildren: BusinessLayoutRouteChildren = {
  BusinessLayoutAboutRoute: BusinessLayoutAboutRoute,
  BusinessLayoutCalendarRoute: BusinessLayoutCalendarRoute,
  BusinessLayoutCompanyPhotoAddRoute: BusinessLayoutCompanyPhotoAddRoute,
  BusinessLayoutContractRequestDetailRoute:
    BusinessLayoutContractRequestDetailRoute,
  BusinessLayoutContractRequestSendRoute:
    BusinessLayoutContractRequestSendRoute,
  BusinessLayoutContractStatusRoute: BusinessLayoutContractStatusRoute,
  BusinessLayoutContractTemplateEditRoute:
    BusinessLayoutContractTemplateEditRoute,
  BusinessLayoutContractTemplateImportRoute:
    BusinessLayoutContractTemplateImportRoute,
  BusinessLayoutContractTemplatesRoute: BusinessLayoutContractTemplatesRoute,
  BusinessLayoutGalleryRoute: BusinessLayoutGalleryRoute,
  BusinessLayoutGalleryAddRoute: BusinessLayoutGalleryAddRoute,
  BusinessLayoutHomeRoute: BusinessLayoutHomeRoute,
  BusinessLayoutManualReserveRoute: BusinessLayoutManualReserveRoute,
  BusinessLayoutNotifyRoute: BusinessLayoutNotifyRoute,
  BusinessLayoutNotifyBatchRoute: BusinessLayoutNotifyBatchRoute,
  BusinessLayoutNotifyDetailRoute: BusinessLayoutNotifyDetailRoute,
  BusinessLayoutNotifySavedNotifyRoute: BusinessLayoutNotifySavedNotifyRoute,
  BusinessLayoutNotifySendRoute: BusinessLayoutNotifySendRoute,
  BusinessLayoutNotifyStyleRoute: BusinessLayoutNotifyStyleRoute,
  BusinessLayoutReservationWithIssuedTicketRoute:
    BusinessLayoutReservationWithIssuedTicketRoute,
  BusinessLayoutRevservationRoute: BusinessLayoutRevservationRoute,
  BusinessLayoutSealManagementRoute: BusinessLayoutSealManagementRoute,
  BusinessLayoutTeacherRoute: BusinessLayoutTeacherRoute,
  BusinessLayoutToSchoolRoute: BusinessLayoutToSchoolRoute,
  BusinessLayoutUserRoute: BusinessLayoutUserRoute,
  BusinessLayoutUserBusinessInfoRoute: BusinessLayoutUserBusinessInfoRoute,
  BusinessLayoutUserBusinessPhotoManagementRoute:
    BusinessLayoutUserBusinessPhotoManagementRoute,
  BusinessLayoutUserBusinessTimeManagementRoute:
    BusinessLayoutUserBusinessTimeManagementRoute,
  BusinessLayoutUserContractDetailRoute: BusinessLayoutUserContractDetailRoute,
  BusinessLayoutUserContractManagementRoute:
    BusinessLayoutUserContractManagementRoute,
  BusinessLayoutUserContractManagementOldRoute:
    BusinessLayoutUserContractManagementOldRoute,
  BusinessLayoutUserCreditWalletRoute: BusinessLayoutUserCreditWalletRoute,
  BusinessLayoutUserCreditWalletChargeRoute:
    BusinessLayoutUserCreditWalletChargeRoute,
  BusinessLayoutUserCreditWalletChargeFailRoute:
    BusinessLayoutUserCreditWalletChargeFailRoute,
  BusinessLayoutUserCreditWalletChargeSuccessRoute:
    BusinessLayoutUserCreditWalletChargeSuccessRoute,
  BusinessLayoutUserCustomerInfoRoute: BusinessLayoutUserCustomerInfoRoute,
  BusinessLayoutUserCustomerManagementRoute:
    BusinessLayoutUserCustomerManagementRoute,
  BusinessLayoutUserCustomerManagementDetailRoute:
    BusinessLayoutUserCustomerManagementDetailRoute,
  BusinessLayoutUserEmployeeDetailRoute: BusinessLayoutUserEmployeeDetailRoute,
  BusinessLayoutUserEmployeeManagementRoute:
    BusinessLayoutUserEmployeeManagementRoute,
  BusinessLayoutUserOwnerAnnouncementRoute:
    BusinessLayoutUserOwnerAnnouncementRoute,
  BusinessLayoutUserOwnerAnnouncementDetailRoute:
    BusinessLayoutUserOwnerAnnouncementDetailRoute,
  BusinessLayoutUserOwnerInfoRoute: BusinessLayoutUserOwnerInfoRoute,
  BusinessLayoutUserOwnerPushRoute: BusinessLayoutUserOwnerPushRoute,
  BusinessLayoutUserOwnerSettingRoute: BusinessLayoutUserOwnerSettingRoute,
  BusinessLayoutUserPaymentHistoryRoute: BusinessLayoutUserPaymentHistoryRoute,
  BusinessLayoutUserProductManagementRoute:
    BusinessLayoutUserProductManagementRoute,
  BusinessLayoutUserServiceStatisticsRoute:
    BusinessLayoutUserServiceStatisticsRoute,
  BusinessLayoutUserSubscriptionAddEditRoute:
    BusinessLayoutUserSubscriptionAddEditRoute,
  BusinessLayoutUserSubscriptionIssueRoute:
    BusinessLayoutUserSubscriptionIssueRoute,
  BusinessLayoutUserSubscriptionIssueDetailRoute:
    BusinessLayoutUserSubscriptionIssueDetailRoute,
  BusinessLayoutUserSubscriptionIssueHistoryRoute:
    BusinessLayoutUserSubscriptionIssueHistoryRoute,
  BusinessLayoutUserSubscriptionManagementRoute:
    BusinessLayoutUserSubscriptionManagementRoute,
  BusinessLayoutUserSubscriptionOrderEditRoute:
    BusinessLayoutUserSubscriptionOrderEditRoute,
  BusinessLayoutUserTeacherInfoRoute: BusinessLayoutUserTeacherInfoRoute,
  BusinessLayoutUserTeacherPushRoute: BusinessLayoutUserTeacherPushRoute,
  BusinessLayoutUserTeacherSettingRoute: BusinessLayoutUserTeacherSettingRoute,
  BusinessLayoutTestLazyRoute: BusinessLayoutTestLazyRoute,
  BusinessLayoutPaymentTestRoute: BusinessLayoutPaymentTestRoute,
}

const BusinessLayoutRouteWithChildren = BusinessLayoutRoute._addFileChildren(
  BusinessLayoutRouteChildren,
)

interface CustomerLayoutRouteChildren {
  CustomerLayoutAboutRoute: typeof CustomerLayoutAboutRoute
  CustomerLayoutCalendarRoute: typeof CustomerLayoutCalendarRoute
  CustomerLayoutCalendarReservationRoute: typeof CustomerLayoutCalendarReservationRoute
  CustomerLayoutCalendarReservationChgRoute: typeof CustomerLayoutCalendarReservationChgRoute
  CustomerLayoutContractInboxRoute: typeof CustomerLayoutContractInboxRoute
  CustomerLayoutContractSignRoute: typeof CustomerLayoutContractSignRoute
  CustomerLayoutGalleryRoute: typeof CustomerLayoutGalleryRoute
  CustomerLayoutGalleryDetailRoute: typeof CustomerLayoutGalleryDetailRoute
  CustomerLayoutHomeRoute: typeof CustomerLayoutHomeRoute
  CustomerLayoutHomeAlertRoute: typeof CustomerLayoutHomeAlertRoute
  CustomerLayoutHomeSerachDetailRoute: typeof CustomerLayoutHomeSerachDetailRoute
  CustomerLayoutHomeSerachStoreRoute: typeof CustomerLayoutHomeSerachStoreRoute
  CustomerLayoutInfoSuggestRoute: typeof CustomerLayoutInfoSuggestRoute
  CustomerLayoutInformRoute: typeof CustomerLayoutInformRoute
  CustomerLayoutInformDetailRoute: typeof CustomerLayoutInformDetailRoute
  CustomerLayoutInformSendRoute: typeof CustomerLayoutInformSendRoute
  CustomerLayoutInformSendFixRoute: typeof CustomerLayoutInformSendFixRoute
  CustomerLayoutInquiryHistoryRoute: typeof CustomerLayoutInquiryHistoryRoute
  CustomerLayoutMapRoute: typeof CustomerLayoutMapRoute
  CustomerLayoutMapListRoute: typeof CustomerLayoutMapListRoute
  CustomerLayoutMemberCodeRoute: typeof CustomerLayoutMemberCodeRoute
  CustomerLayoutReservationRoute: typeof CustomerLayoutReservationRoute
  CustomerLayoutReservationWithSubscriptionRoute: typeof CustomerLayoutReservationWithSubscriptionRoute
  CustomerLayoutSearchRoute: typeof CustomerLayoutSearchRoute
  CustomerLayoutSubscriptionListRoute: typeof CustomerLayoutSubscriptionListRoute
  CustomerLayoutToSchoolRoute: typeof CustomerLayoutToSchoolRoute
  CustomerLayoutUserRoute: typeof CustomerLayoutUserRoute
  CustomerLayoutUserAnnouncementRoute: typeof CustomerLayoutUserAnnouncementRoute
  CustomerLayoutUserAnnouncementDetailRoute: typeof CustomerLayoutUserAnnouncementDetailRoute
  CustomerLayoutUserBuyCoinRoute: typeof CustomerLayoutUserBuyCoinRoute
  CustomerLayoutUserContractRoute: typeof CustomerLayoutUserContractRoute
  CustomerLayoutUserContractDetailRoute: typeof CustomerLayoutUserContractDetailRoute
  CustomerLayoutUserGuardianLinkRoute: typeof CustomerLayoutUserGuardianLinkRoute
  CustomerLayoutUserInfoChgRoute: typeof CustomerLayoutUserInfoChgRoute
  CustomerLayoutUserPetInfoRoute: typeof CustomerLayoutUserPetInfoRoute
  CustomerLayoutUserPetInfoAddRoute: typeof CustomerLayoutUserPetInfoAddRoute
  CustomerLayoutUserPetInfoChgRoute: typeof CustomerLayoutUserPetInfoChgRoute
  CustomerLayoutUserPushRoute: typeof CustomerLayoutUserPushRoute
  CustomerLayoutUserSubscriptionDetailRoute: typeof CustomerLayoutUserSubscriptionDetailRoute
  CustomerLayoutUserSubscriptionsRoute: typeof CustomerLayoutUserSubscriptionsRoute
  CustomerLayoutUserUsageHistoryRoute: typeof CustomerLayoutUserUsageHistoryRoute
  CustomerLayoutUserUsageHistoryDetailRoute: typeof CustomerLayoutUserUsageHistoryDetailRoute
  CustomerLayoutTestLazyRoute: typeof CustomerLayoutTestLazyRoute
  CustomerLayoutPaymentAuthRoute: typeof CustomerLayoutPaymentAuthRoute
  CustomerLayoutPaymentFailRoute: typeof CustomerLayoutPaymentFailRoute
  CustomerLayoutPaymentIndexcopyRoute: typeof CustomerLayoutPaymentIndexcopyRoute
  CustomerLayoutPaymentSuccessRoute: typeof CustomerLayoutPaymentSuccessRoute
  CustomerLayoutPaymentIndexRoute: typeof CustomerLayoutPaymentIndexRoute
}

const CustomerLayoutRouteChildren: CustomerLayoutRouteChildren = {
  CustomerLayoutAboutRoute: CustomerLayoutAboutRoute,
  CustomerLayoutCalendarRoute: CustomerLayoutCalendarRoute,
  CustomerLayoutCalendarReservationRoute:
    CustomerLayoutCalendarReservationRoute,
  CustomerLayoutCalendarReservationChgRoute:
    CustomerLayoutCalendarReservationChgRoute,
  CustomerLayoutContractInboxRoute: CustomerLayoutContractInboxRoute,
  CustomerLayoutContractSignRoute: CustomerLayoutContractSignRoute,
  CustomerLayoutGalleryRoute: CustomerLayoutGalleryRoute,
  CustomerLayoutGalleryDetailRoute: CustomerLayoutGalleryDetailRoute,
  CustomerLayoutHomeRoute: CustomerLayoutHomeRoute,
  CustomerLayoutHomeAlertRoute: CustomerLayoutHomeAlertRoute,
  CustomerLayoutHomeSerachDetailRoute: CustomerLayoutHomeSerachDetailRoute,
  CustomerLayoutHomeSerachStoreRoute: CustomerLayoutHomeSerachStoreRoute,
  CustomerLayoutInfoSuggestRoute: CustomerLayoutInfoSuggestRoute,
  CustomerLayoutInformRoute: CustomerLayoutInformRoute,
  CustomerLayoutInformDetailRoute: CustomerLayoutInformDetailRoute,
  CustomerLayoutInformSendRoute: CustomerLayoutInformSendRoute,
  CustomerLayoutInformSendFixRoute: CustomerLayoutInformSendFixRoute,
  CustomerLayoutInquiryHistoryRoute: CustomerLayoutInquiryHistoryRoute,
  CustomerLayoutMapRoute: CustomerLayoutMapRoute,
  CustomerLayoutMapListRoute: CustomerLayoutMapListRoute,
  CustomerLayoutMemberCodeRoute: CustomerLayoutMemberCodeRoute,
  CustomerLayoutReservationRoute: CustomerLayoutReservationRoute,
  CustomerLayoutReservationWithSubscriptionRoute:
    CustomerLayoutReservationWithSubscriptionRoute,
  CustomerLayoutSearchRoute: CustomerLayoutSearchRoute,
  CustomerLayoutSubscriptionListRoute: CustomerLayoutSubscriptionListRoute,
  CustomerLayoutToSchoolRoute: CustomerLayoutToSchoolRoute,
  CustomerLayoutUserRoute: CustomerLayoutUserRoute,
  CustomerLayoutUserAnnouncementRoute: CustomerLayoutUserAnnouncementRoute,
  CustomerLayoutUserAnnouncementDetailRoute:
    CustomerLayoutUserAnnouncementDetailRoute,
  CustomerLayoutUserBuyCoinRoute: CustomerLayoutUserBuyCoinRoute,
  CustomerLayoutUserContractRoute: CustomerLayoutUserContractRoute,
  CustomerLayoutUserContractDetailRoute: CustomerLayoutUserContractDetailRoute,
  CustomerLayoutUserGuardianLinkRoute: CustomerLayoutUserGuardianLinkRoute,
  CustomerLayoutUserInfoChgRoute: CustomerLayoutUserInfoChgRoute,
  CustomerLayoutUserPetInfoRoute: CustomerLayoutUserPetInfoRoute,
  CustomerLayoutUserPetInfoAddRoute: CustomerLayoutUserPetInfoAddRoute,
  CustomerLayoutUserPetInfoChgRoute: CustomerLayoutUserPetInfoChgRoute,
  CustomerLayoutUserPushRoute: CustomerLayoutUserPushRoute,
  CustomerLayoutUserSubscriptionDetailRoute:
    CustomerLayoutUserSubscriptionDetailRoute,
  CustomerLayoutUserSubscriptionsRoute: CustomerLayoutUserSubscriptionsRoute,
  CustomerLayoutUserUsageHistoryRoute: CustomerLayoutUserUsageHistoryRoute,
  CustomerLayoutUserUsageHistoryDetailRoute:
    CustomerLayoutUserUsageHistoryDetailRoute,
  CustomerLayoutTestLazyRoute: CustomerLayoutTestLazyRoute,
  CustomerLayoutPaymentAuthRoute: CustomerLayoutPaymentAuthRoute,
  CustomerLayoutPaymentFailRoute: CustomerLayoutPaymentFailRoute,
  CustomerLayoutPaymentIndexcopyRoute: CustomerLayoutPaymentIndexcopyRoute,
  CustomerLayoutPaymentSuccessRoute: CustomerLayoutPaymentSuccessRoute,
  CustomerLayoutPaymentIndexRoute: CustomerLayoutPaymentIndexRoute,
}

const CustomerLayoutRouteWithChildren = CustomerLayoutRoute._addFileChildren(
  CustomerLayoutRouteChildren,
)

interface OauthGoogleRouteChildren {
  OauthGoogleCallbackRoute: typeof OauthGoogleCallbackRoute
}

const OauthGoogleRouteChildren: OauthGoogleRouteChildren = {
  OauthGoogleCallbackRoute: OauthGoogleCallbackRoute,
}

const OauthGoogleRouteWithChildren = OauthGoogleRoute._addFileChildren(
  OauthGoogleRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login-stage': typeof LoginStageRoute
  '/policy': typeof PolicyRoute
  '/sign-up': typeof SignUpRouteWithChildren
  '/auth/handoff': typeof AuthHandoffRoute
  '/business/layout': typeof BusinessLayoutRouteWithChildren
  '/customer/alert': typeof CustomerAlertRoute
  '/customer/layout': typeof CustomerLayoutRouteWithChildren
  '/oauth/google': typeof OauthGoogleRouteWithChildren
  '/oauth/kakao': typeof OauthKakaoRoute
  '/oauth/naver': typeof OauthNaverRoute
  '/sign-up/business-owner': typeof SignUpBusinessOwnerRoute
  '/sign-up/business-owner-detail': typeof SignUpBusinessOwnerDetailRoute
  '/sign-up/business-owner-done': typeof SignUpBusinessOwnerDoneRoute
  '/sign-up/business-teacher': typeof SignUpBusinessTeacherRoute
  '/sign-up/business-teacher-done': typeof SignUpBusinessTeacherDoneRoute
  '/sign-up/customer': typeof SignUpCustomerRoute
  '/sign-up/customer-done': typeof SignUpCustomerDoneRoute
  '/sign-up/pet': typeof SignUpPetRoute
  '/sign-up/': typeof SignUpIndexRoute
  '/business/layout/about': typeof BusinessLayoutAboutRoute
  '/business/layout/calendar': typeof BusinessLayoutCalendarRoute
  '/business/layout/company-photo-add': typeof BusinessLayoutCompanyPhotoAddRoute
  '/business/layout/contract-request-detail': typeof BusinessLayoutContractRequestDetailRoute
  '/business/layout/contract-request-send': typeof BusinessLayoutContractRequestSendRoute
  '/business/layout/contract-status': typeof BusinessLayoutContractStatusRoute
  '/business/layout/contract-template-edit': typeof BusinessLayoutContractTemplateEditRoute
  '/business/layout/contract-template-import': typeof BusinessLayoutContractTemplateImportRoute
  '/business/layout/contract-templates': typeof BusinessLayoutContractTemplatesRoute
  '/business/layout/gallery': typeof BusinessLayoutGalleryRoute
  '/business/layout/gallery-add': typeof BusinessLayoutGalleryAddRoute
  '/business/layout/home': typeof BusinessLayoutHomeRoute
  '/business/layout/manual-reserve': typeof BusinessLayoutManualReserveRoute
  '/business/layout/notify': typeof BusinessLayoutNotifyRoute
  '/business/layout/notify-batch': typeof BusinessLayoutNotifyBatchRoute
  '/business/layout/notify-detail': typeof BusinessLayoutNotifyDetailRoute
  '/business/layout/notify-saved-notify': typeof BusinessLayoutNotifySavedNotifyRoute
  '/business/layout/notify-send': typeof BusinessLayoutNotifySendRoute
  '/business/layout/notify-style': typeof BusinessLayoutNotifyStyleRoute
  '/business/layout/reservation-with-issued-ticket': typeof BusinessLayoutReservationWithIssuedTicketRoute
  '/business/layout/revservation': typeof BusinessLayoutRevservationRoute
  '/business/layout/seal-management': typeof BusinessLayoutSealManagementRoute
  '/business/layout/teacher': typeof BusinessLayoutTeacherRoute
  '/business/layout/to-school': typeof BusinessLayoutToSchoolRoute
  '/business/layout/user': typeof BusinessLayoutUserRoute
  '/business/layout/user-business-info': typeof BusinessLayoutUserBusinessInfoRoute
  '/business/layout/user-business-photo-management': typeof BusinessLayoutUserBusinessPhotoManagementRoute
  '/business/layout/user-business-time-management': typeof BusinessLayoutUserBusinessTimeManagementRoute
  '/business/layout/user-contract-detail': typeof BusinessLayoutUserContractDetailRoute
  '/business/layout/user-contract-management': typeof BusinessLayoutUserContractManagementRoute
  '/business/layout/user-contract-managementOld': typeof BusinessLayoutUserContractManagementOldRoute
  '/business/layout/user-credit-wallet': typeof BusinessLayoutUserCreditWalletRoute
  '/business/layout/user-credit-wallet-charge': typeof BusinessLayoutUserCreditWalletChargeRoute
  '/business/layout/user-credit-wallet-charge-fail': typeof BusinessLayoutUserCreditWalletChargeFailRoute
  '/business/layout/user-credit-wallet-charge-success': typeof BusinessLayoutUserCreditWalletChargeSuccessRoute
  '/business/layout/user-customer-info': typeof BusinessLayoutUserCustomerInfoRoute
  '/business/layout/user-customer-management': typeof BusinessLayoutUserCustomerManagementRoute
  '/business/layout/user-customer-management-detail': typeof BusinessLayoutUserCustomerManagementDetailRoute
  '/business/layout/user-employee-detail': typeof BusinessLayoutUserEmployeeDetailRoute
  '/business/layout/user-employee-management': typeof BusinessLayoutUserEmployeeManagementRoute
  '/business/layout/user-owner-announcement': typeof BusinessLayoutUserOwnerAnnouncementRoute
  '/business/layout/user-owner-announcement-detail': typeof BusinessLayoutUserOwnerAnnouncementDetailRoute
  '/business/layout/user-owner-info': typeof BusinessLayoutUserOwnerInfoRoute
  '/business/layout/user-owner-push': typeof BusinessLayoutUserOwnerPushRoute
  '/business/layout/user-owner-setting': typeof BusinessLayoutUserOwnerSettingRoute
  '/business/layout/user-payment-history': typeof BusinessLayoutUserPaymentHistoryRoute
  '/business/layout/user-product-management': typeof BusinessLayoutUserProductManagementRoute
  '/business/layout/user-service-statistics': typeof BusinessLayoutUserServiceStatisticsRoute
  '/business/layout/user-subscription-add-edit': typeof BusinessLayoutUserSubscriptionAddEditRoute
  '/business/layout/user-subscription-issue': typeof BusinessLayoutUserSubscriptionIssueRoute
  '/business/layout/user-subscription-issue-detail': typeof BusinessLayoutUserSubscriptionIssueDetailRoute
  '/business/layout/user-subscription-issue-history': typeof BusinessLayoutUserSubscriptionIssueHistoryRoute
  '/business/layout/user-subscription-management': typeof BusinessLayoutUserSubscriptionManagementRoute
  '/business/layout/user-subscription-order-edit': typeof BusinessLayoutUserSubscriptionOrderEditRoute
  '/business/layout/user-teacher-info': typeof BusinessLayoutUserTeacherInfoRoute
  '/business/layout/user-teacher-push': typeof BusinessLayoutUserTeacherPushRoute
  '/business/layout/user-teacher-setting': typeof BusinessLayoutUserTeacherSettingRoute
  '/customer/layout/about': typeof CustomerLayoutAboutRoute
  '/customer/layout/calendar': typeof CustomerLayoutCalendarRoute
  '/customer/layout/calendar-reservation': typeof CustomerLayoutCalendarReservationRoute
  '/customer/layout/calendar-reservation-chg': typeof CustomerLayoutCalendarReservationChgRoute
  '/customer/layout/contract-inbox': typeof CustomerLayoutContractInboxRoute
  '/customer/layout/contract-sign': typeof CustomerLayoutContractSignRoute
  '/customer/layout/gallery': typeof CustomerLayoutGalleryRoute
  '/customer/layout/gallery-detail': typeof CustomerLayoutGalleryDetailRoute
  '/customer/layout/home': typeof CustomerLayoutHomeRoute
  '/customer/layout/home-alert': typeof CustomerLayoutHomeAlertRoute
  '/customer/layout/home-serach-detail': typeof CustomerLayoutHomeSerachDetailRoute
  '/customer/layout/home-serach-store': typeof CustomerLayoutHomeSerachStoreRoute
  '/customer/layout/info-suggest': typeof CustomerLayoutInfoSuggestRoute
  '/customer/layout/inform': typeof CustomerLayoutInformRoute
  '/customer/layout/inform-detail': typeof CustomerLayoutInformDetailRoute
  '/customer/layout/inform-send': typeof CustomerLayoutInformSendRoute
  '/customer/layout/inform-send-fix': typeof CustomerLayoutInformSendFixRoute
  '/customer/layout/inquiry-history': typeof CustomerLayoutInquiryHistoryRoute
  '/customer/layout/map': typeof CustomerLayoutMapRoute
  '/customer/layout/map-list': typeof CustomerLayoutMapListRoute
  '/customer/layout/member-code': typeof CustomerLayoutMemberCodeRoute
  '/customer/layout/reservation': typeof CustomerLayoutReservationRoute
  '/customer/layout/reservation-with-subscription': typeof CustomerLayoutReservationWithSubscriptionRoute
  '/customer/layout/search': typeof CustomerLayoutSearchRoute
  '/customer/layout/subscription-list': typeof CustomerLayoutSubscriptionListRoute
  '/customer/layout/to-school': typeof CustomerLayoutToSchoolRoute
  '/customer/layout/user': typeof CustomerLayoutUserRoute
  '/customer/layout/user-announcement': typeof CustomerLayoutUserAnnouncementRoute
  '/customer/layout/user-announcement-detail': typeof CustomerLayoutUserAnnouncementDetailRoute
  '/customer/layout/user-buy-coin': typeof CustomerLayoutUserBuyCoinRoute
  '/customer/layout/user-contract': typeof CustomerLayoutUserContractRoute
  '/customer/layout/user-contract-detail': typeof CustomerLayoutUserContractDetailRoute
  '/customer/layout/user-guardian-link': typeof CustomerLayoutUserGuardianLinkRoute
  '/customer/layout/user-info-Chg': typeof CustomerLayoutUserInfoChgRoute
  '/customer/layout/user-pet-info': typeof CustomerLayoutUserPetInfoRoute
  '/customer/layout/user-pet-info-add': typeof CustomerLayoutUserPetInfoAddRoute
  '/customer/layout/user-pet-info-chg': typeof CustomerLayoutUserPetInfoChgRoute
  '/customer/layout/user-push': typeof CustomerLayoutUserPushRoute
  '/customer/layout/user-subscription-detail': typeof CustomerLayoutUserSubscriptionDetailRoute
  '/customer/layout/user-subscriptions': typeof CustomerLayoutUserSubscriptionsRoute
  '/customer/layout/user-usage-history': typeof CustomerLayoutUserUsageHistoryRoute
  '/customer/layout/user-usage-history-detail': typeof CustomerLayoutUserUsageHistoryDetailRoute
  '/oauth/google/callback': typeof OauthGoogleCallbackRoute
  '/business/layout/test': typeof BusinessLayoutTestLazyRoute
  '/customer/layout/test': typeof CustomerLayoutTestLazyRoute
  '/business/layout/payment/test': typeof BusinessLayoutPaymentTestRoute
  '/customer/layout/payment/auth': typeof CustomerLayoutPaymentAuthRoute
  '/customer/layout/payment/fail': typeof CustomerLayoutPaymentFailRoute
  '/customer/layout/payment/index copy': typeof CustomerLayoutPaymentIndexcopyRoute
  '/customer/layout/payment/success': typeof CustomerLayoutPaymentSuccessRoute
  '/customer/layout/payment': typeof CustomerLayoutPaymentIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login-stage': typeof LoginStageRoute
  '/policy': typeof PolicyRoute
  '/auth/handoff': typeof AuthHandoffRoute
  '/business/layout': typeof BusinessLayoutRouteWithChildren
  '/customer/alert': typeof CustomerAlertRoute
  '/customer/layout': typeof CustomerLayoutRouteWithChildren
  '/oauth/google': typeof OauthGoogleRouteWithChildren
  '/oauth/kakao': typeof OauthKakaoRoute
  '/oauth/naver': typeof OauthNaverRoute
  '/sign-up/business-owner': typeof SignUpBusinessOwnerRoute
  '/sign-up/business-owner-detail': typeof SignUpBusinessOwnerDetailRoute
  '/sign-up/business-owner-done': typeof SignUpBusinessOwnerDoneRoute
  '/sign-up/business-teacher': typeof SignUpBusinessTeacherRoute
  '/sign-up/business-teacher-done': typeof SignUpBusinessTeacherDoneRoute
  '/sign-up/customer': typeof SignUpCustomerRoute
  '/sign-up/customer-done': typeof SignUpCustomerDoneRoute
  '/sign-up/pet': typeof SignUpPetRoute
  '/sign-up': typeof SignUpIndexRoute
  '/business/layout/about': typeof BusinessLayoutAboutRoute
  '/business/layout/calendar': typeof BusinessLayoutCalendarRoute
  '/business/layout/company-photo-add': typeof BusinessLayoutCompanyPhotoAddRoute
  '/business/layout/contract-request-detail': typeof BusinessLayoutContractRequestDetailRoute
  '/business/layout/contract-request-send': typeof BusinessLayoutContractRequestSendRoute
  '/business/layout/contract-status': typeof BusinessLayoutContractStatusRoute
  '/business/layout/contract-template-edit': typeof BusinessLayoutContractTemplateEditRoute
  '/business/layout/contract-template-import': typeof BusinessLayoutContractTemplateImportRoute
  '/business/layout/contract-templates': typeof BusinessLayoutContractTemplatesRoute
  '/business/layout/gallery': typeof BusinessLayoutGalleryRoute
  '/business/layout/gallery-add': typeof BusinessLayoutGalleryAddRoute
  '/business/layout/home': typeof BusinessLayoutHomeRoute
  '/business/layout/manual-reserve': typeof BusinessLayoutManualReserveRoute
  '/business/layout/notify': typeof BusinessLayoutNotifyRoute
  '/business/layout/notify-batch': typeof BusinessLayoutNotifyBatchRoute
  '/business/layout/notify-detail': typeof BusinessLayoutNotifyDetailRoute
  '/business/layout/notify-saved-notify': typeof BusinessLayoutNotifySavedNotifyRoute
  '/business/layout/notify-send': typeof BusinessLayoutNotifySendRoute
  '/business/layout/notify-style': typeof BusinessLayoutNotifyStyleRoute
  '/business/layout/reservation-with-issued-ticket': typeof BusinessLayoutReservationWithIssuedTicketRoute
  '/business/layout/revservation': typeof BusinessLayoutRevservationRoute
  '/business/layout/seal-management': typeof BusinessLayoutSealManagementRoute
  '/business/layout/teacher': typeof BusinessLayoutTeacherRoute
  '/business/layout/to-school': typeof BusinessLayoutToSchoolRoute
  '/business/layout/user': typeof BusinessLayoutUserRoute
  '/business/layout/user-business-info': typeof BusinessLayoutUserBusinessInfoRoute
  '/business/layout/user-business-photo-management': typeof BusinessLayoutUserBusinessPhotoManagementRoute
  '/business/layout/user-business-time-management': typeof BusinessLayoutUserBusinessTimeManagementRoute
  '/business/layout/user-contract-detail': typeof BusinessLayoutUserContractDetailRoute
  '/business/layout/user-contract-management': typeof BusinessLayoutUserContractManagementRoute
  '/business/layout/user-contract-managementOld': typeof BusinessLayoutUserContractManagementOldRoute
  '/business/layout/user-credit-wallet': typeof BusinessLayoutUserCreditWalletRoute
  '/business/layout/user-credit-wallet-charge': typeof BusinessLayoutUserCreditWalletChargeRoute
  '/business/layout/user-credit-wallet-charge-fail': typeof BusinessLayoutUserCreditWalletChargeFailRoute
  '/business/layout/user-credit-wallet-charge-success': typeof BusinessLayoutUserCreditWalletChargeSuccessRoute
  '/business/layout/user-customer-info': typeof BusinessLayoutUserCustomerInfoRoute
  '/business/layout/user-customer-management': typeof BusinessLayoutUserCustomerManagementRoute
  '/business/layout/user-customer-management-detail': typeof BusinessLayoutUserCustomerManagementDetailRoute
  '/business/layout/user-employee-detail': typeof BusinessLayoutUserEmployeeDetailRoute
  '/business/layout/user-employee-management': typeof BusinessLayoutUserEmployeeManagementRoute
  '/business/layout/user-owner-announcement': typeof BusinessLayoutUserOwnerAnnouncementRoute
  '/business/layout/user-owner-announcement-detail': typeof BusinessLayoutUserOwnerAnnouncementDetailRoute
  '/business/layout/user-owner-info': typeof BusinessLayoutUserOwnerInfoRoute
  '/business/layout/user-owner-push': typeof BusinessLayoutUserOwnerPushRoute
  '/business/layout/user-owner-setting': typeof BusinessLayoutUserOwnerSettingRoute
  '/business/layout/user-payment-history': typeof BusinessLayoutUserPaymentHistoryRoute
  '/business/layout/user-product-management': typeof BusinessLayoutUserProductManagementRoute
  '/business/layout/user-service-statistics': typeof BusinessLayoutUserServiceStatisticsRoute
  '/business/layout/user-subscription-add-edit': typeof BusinessLayoutUserSubscriptionAddEditRoute
  '/business/layout/user-subscription-issue': typeof BusinessLayoutUserSubscriptionIssueRoute
  '/business/layout/user-subscription-issue-detail': typeof BusinessLayoutUserSubscriptionIssueDetailRoute
  '/business/layout/user-subscription-issue-history': typeof BusinessLayoutUserSubscriptionIssueHistoryRoute
  '/business/layout/user-subscription-management': typeof BusinessLayoutUserSubscriptionManagementRoute
  '/business/layout/user-subscription-order-edit': typeof BusinessLayoutUserSubscriptionOrderEditRoute
  '/business/layout/user-teacher-info': typeof BusinessLayoutUserTeacherInfoRoute
  '/business/layout/user-teacher-push': typeof BusinessLayoutUserTeacherPushRoute
  '/business/layout/user-teacher-setting': typeof BusinessLayoutUserTeacherSettingRoute
  '/customer/layout/about': typeof CustomerLayoutAboutRoute
  '/customer/layout/calendar': typeof CustomerLayoutCalendarRoute
  '/customer/layout/calendar-reservation': typeof CustomerLayoutCalendarReservationRoute
  '/customer/layout/calendar-reservation-chg': typeof CustomerLayoutCalendarReservationChgRoute
  '/customer/layout/contract-inbox': typeof CustomerLayoutContractInboxRoute
  '/customer/layout/contract-sign': typeof CustomerLayoutContractSignRoute
  '/customer/layout/gallery': typeof CustomerLayoutGalleryRoute
  '/customer/layout/gallery-detail': typeof CustomerLayoutGalleryDetailRoute
  '/customer/layout/home': typeof CustomerLayoutHomeRoute
  '/customer/layout/home-alert': typeof CustomerLayoutHomeAlertRoute
  '/customer/layout/home-serach-detail': typeof CustomerLayoutHomeSerachDetailRoute
  '/customer/layout/home-serach-store': typeof CustomerLayoutHomeSerachStoreRoute
  '/customer/layout/info-suggest': typeof CustomerLayoutInfoSuggestRoute
  '/customer/layout/inform': typeof CustomerLayoutInformRoute
  '/customer/layout/inform-detail': typeof CustomerLayoutInformDetailRoute
  '/customer/layout/inform-send': typeof CustomerLayoutInformSendRoute
  '/customer/layout/inform-send-fix': typeof CustomerLayoutInformSendFixRoute
  '/customer/layout/inquiry-history': typeof CustomerLayoutInquiryHistoryRoute
  '/customer/layout/map': typeof CustomerLayoutMapRoute
  '/customer/layout/map-list': typeof CustomerLayoutMapListRoute
  '/customer/layout/member-code': typeof CustomerLayoutMemberCodeRoute
  '/customer/layout/reservation': typeof CustomerLayoutReservationRoute
  '/customer/layout/reservation-with-subscription': typeof CustomerLayoutReservationWithSubscriptionRoute
  '/customer/layout/search': typeof CustomerLayoutSearchRoute
  '/customer/layout/subscription-list': typeof CustomerLayoutSubscriptionListRoute
  '/customer/layout/to-school': typeof CustomerLayoutToSchoolRoute
  '/customer/layout/user': typeof CustomerLayoutUserRoute
  '/customer/layout/user-announcement': typeof CustomerLayoutUserAnnouncementRoute
  '/customer/layout/user-announcement-detail': typeof CustomerLayoutUserAnnouncementDetailRoute
  '/customer/layout/user-buy-coin': typeof CustomerLayoutUserBuyCoinRoute
  '/customer/layout/user-contract': typeof CustomerLayoutUserContractRoute
  '/customer/layout/user-contract-detail': typeof CustomerLayoutUserContractDetailRoute
  '/customer/layout/user-guardian-link': typeof CustomerLayoutUserGuardianLinkRoute
  '/customer/layout/user-info-Chg': typeof CustomerLayoutUserInfoChgRoute
  '/customer/layout/user-pet-info': typeof CustomerLayoutUserPetInfoRoute
  '/customer/layout/user-pet-info-add': typeof CustomerLayoutUserPetInfoAddRoute
  '/customer/layout/user-pet-info-chg': typeof CustomerLayoutUserPetInfoChgRoute
  '/customer/layout/user-push': typeof CustomerLayoutUserPushRoute
  '/customer/layout/user-subscription-detail': typeof CustomerLayoutUserSubscriptionDetailRoute
  '/customer/layout/user-subscriptions': typeof CustomerLayoutUserSubscriptionsRoute
  '/customer/layout/user-usage-history': typeof CustomerLayoutUserUsageHistoryRoute
  '/customer/layout/user-usage-history-detail': typeof CustomerLayoutUserUsageHistoryDetailRoute
  '/oauth/google/callback': typeof OauthGoogleCallbackRoute
  '/business/layout/test': typeof BusinessLayoutTestLazyRoute
  '/customer/layout/test': typeof CustomerLayoutTestLazyRoute
  '/business/layout/payment/test': typeof BusinessLayoutPaymentTestRoute
  '/customer/layout/payment/auth': typeof CustomerLayoutPaymentAuthRoute
  '/customer/layout/payment/fail': typeof CustomerLayoutPaymentFailRoute
  '/customer/layout/payment/index copy': typeof CustomerLayoutPaymentIndexcopyRoute
  '/customer/layout/payment/success': typeof CustomerLayoutPaymentSuccessRoute
  '/customer/layout/payment': typeof CustomerLayoutPaymentIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/login-stage': typeof LoginStageRoute
  '/policy': typeof PolicyRoute
  '/sign-up': typeof SignUpRouteWithChildren
  '/auth/handoff': typeof AuthHandoffRoute
  '/business/layout': typeof BusinessLayoutRouteWithChildren
  '/customer/alert': typeof CustomerAlertRoute
  '/customer/layout': typeof CustomerLayoutRouteWithChildren
  '/oauth/google': typeof OauthGoogleRouteWithChildren
  '/oauth/kakao': typeof OauthKakaoRoute
  '/oauth/naver': typeof OauthNaverRoute
  '/sign-up/business-owner': typeof SignUpBusinessOwnerRoute
  '/sign-up/business-owner-detail': typeof SignUpBusinessOwnerDetailRoute
  '/sign-up/business-owner-done': typeof SignUpBusinessOwnerDoneRoute
  '/sign-up/business-teacher': typeof SignUpBusinessTeacherRoute
  '/sign-up/business-teacher-done': typeof SignUpBusinessTeacherDoneRoute
  '/sign-up/customer': typeof SignUpCustomerRoute
  '/sign-up/customer-done': typeof SignUpCustomerDoneRoute
  '/sign-up/pet': typeof SignUpPetRoute
  '/sign-up/': typeof SignUpIndexRoute
  '/business/layout/about': typeof BusinessLayoutAboutRoute
  '/business/layout/calendar': typeof BusinessLayoutCalendarRoute
  '/business/layout/company-photo-add': typeof BusinessLayoutCompanyPhotoAddRoute
  '/business/layout/contract-request-detail': typeof BusinessLayoutContractRequestDetailRoute
  '/business/layout/contract-request-send': typeof BusinessLayoutContractRequestSendRoute
  '/business/layout/contract-status': typeof BusinessLayoutContractStatusRoute
  '/business/layout/contract-template-edit': typeof BusinessLayoutContractTemplateEditRoute
  '/business/layout/contract-template-import': typeof BusinessLayoutContractTemplateImportRoute
  '/business/layout/contract-templates': typeof BusinessLayoutContractTemplatesRoute
  '/business/layout/gallery': typeof BusinessLayoutGalleryRoute
  '/business/layout/gallery-add': typeof BusinessLayoutGalleryAddRoute
  '/business/layout/home': typeof BusinessLayoutHomeRoute
  '/business/layout/manual-reserve': typeof BusinessLayoutManualReserveRoute
  '/business/layout/notify': typeof BusinessLayoutNotifyRoute
  '/business/layout/notify-batch': typeof BusinessLayoutNotifyBatchRoute
  '/business/layout/notify-detail': typeof BusinessLayoutNotifyDetailRoute
  '/business/layout/notify-saved-notify': typeof BusinessLayoutNotifySavedNotifyRoute
  '/business/layout/notify-send': typeof BusinessLayoutNotifySendRoute
  '/business/layout/notify-style': typeof BusinessLayoutNotifyStyleRoute
  '/business/layout/reservation-with-issued-ticket': typeof BusinessLayoutReservationWithIssuedTicketRoute
  '/business/layout/revservation': typeof BusinessLayoutRevservationRoute
  '/business/layout/seal-management': typeof BusinessLayoutSealManagementRoute
  '/business/layout/teacher': typeof BusinessLayoutTeacherRoute
  '/business/layout/to-school': typeof BusinessLayoutToSchoolRoute
  '/business/layout/user': typeof BusinessLayoutUserRoute
  '/business/layout/user-business-info': typeof BusinessLayoutUserBusinessInfoRoute
  '/business/layout/user-business-photo-management': typeof BusinessLayoutUserBusinessPhotoManagementRoute
  '/business/layout/user-business-time-management': typeof BusinessLayoutUserBusinessTimeManagementRoute
  '/business/layout/user-contract-detail': typeof BusinessLayoutUserContractDetailRoute
  '/business/layout/user-contract-management': typeof BusinessLayoutUserContractManagementRoute
  '/business/layout/user-contract-managementOld': typeof BusinessLayoutUserContractManagementOldRoute
  '/business/layout/user-credit-wallet': typeof BusinessLayoutUserCreditWalletRoute
  '/business/layout/user-credit-wallet-charge': typeof BusinessLayoutUserCreditWalletChargeRoute
  '/business/layout/user-credit-wallet-charge-fail': typeof BusinessLayoutUserCreditWalletChargeFailRoute
  '/business/layout/user-credit-wallet-charge-success': typeof BusinessLayoutUserCreditWalletChargeSuccessRoute
  '/business/layout/user-customer-info': typeof BusinessLayoutUserCustomerInfoRoute
  '/business/layout/user-customer-management': typeof BusinessLayoutUserCustomerManagementRoute
  '/business/layout/user-customer-management-detail': typeof BusinessLayoutUserCustomerManagementDetailRoute
  '/business/layout/user-employee-detail': typeof BusinessLayoutUserEmployeeDetailRoute
  '/business/layout/user-employee-management': typeof BusinessLayoutUserEmployeeManagementRoute
  '/business/layout/user-owner-announcement': typeof BusinessLayoutUserOwnerAnnouncementRoute
  '/business/layout/user-owner-announcement-detail': typeof BusinessLayoutUserOwnerAnnouncementDetailRoute
  '/business/layout/user-owner-info': typeof BusinessLayoutUserOwnerInfoRoute
  '/business/layout/user-owner-push': typeof BusinessLayoutUserOwnerPushRoute
  '/business/layout/user-owner-setting': typeof BusinessLayoutUserOwnerSettingRoute
  '/business/layout/user-payment-history': typeof BusinessLayoutUserPaymentHistoryRoute
  '/business/layout/user-product-management': typeof BusinessLayoutUserProductManagementRoute
  '/business/layout/user-service-statistics': typeof BusinessLayoutUserServiceStatisticsRoute
  '/business/layout/user-subscription-add-edit': typeof BusinessLayoutUserSubscriptionAddEditRoute
  '/business/layout/user-subscription-issue': typeof BusinessLayoutUserSubscriptionIssueRoute
  '/business/layout/user-subscription-issue-detail': typeof BusinessLayoutUserSubscriptionIssueDetailRoute
  '/business/layout/user-subscription-issue-history': typeof BusinessLayoutUserSubscriptionIssueHistoryRoute
  '/business/layout/user-subscription-management': typeof BusinessLayoutUserSubscriptionManagementRoute
  '/business/layout/user-subscription-order-edit': typeof BusinessLayoutUserSubscriptionOrderEditRoute
  '/business/layout/user-teacher-info': typeof BusinessLayoutUserTeacherInfoRoute
  '/business/layout/user-teacher-push': typeof BusinessLayoutUserTeacherPushRoute
  '/business/layout/user-teacher-setting': typeof BusinessLayoutUserTeacherSettingRoute
  '/customer/layout/about': typeof CustomerLayoutAboutRoute
  '/customer/layout/calendar': typeof CustomerLayoutCalendarRoute
  '/customer/layout/calendar-reservation': typeof CustomerLayoutCalendarReservationRoute
  '/customer/layout/calendar-reservation-chg': typeof CustomerLayoutCalendarReservationChgRoute
  '/customer/layout/contract-inbox': typeof CustomerLayoutContractInboxRoute
  '/customer/layout/contract-sign': typeof CustomerLayoutContractSignRoute
  '/customer/layout/gallery': typeof CustomerLayoutGalleryRoute
  '/customer/layout/gallery-detail': typeof CustomerLayoutGalleryDetailRoute
  '/customer/layout/home': typeof CustomerLayoutHomeRoute
  '/customer/layout/home-alert': typeof CustomerLayoutHomeAlertRoute
  '/customer/layout/home-serach-detail': typeof CustomerLayoutHomeSerachDetailRoute
  '/customer/layout/home-serach-store': typeof CustomerLayoutHomeSerachStoreRoute
  '/customer/layout/info-suggest': typeof CustomerLayoutInfoSuggestRoute
  '/customer/layout/inform': typeof CustomerLayoutInformRoute
  '/customer/layout/inform-detail': typeof CustomerLayoutInformDetailRoute
  '/customer/layout/inform-send': typeof CustomerLayoutInformSendRoute
  '/customer/layout/inform-send-fix': typeof CustomerLayoutInformSendFixRoute
  '/customer/layout/inquiry-history': typeof CustomerLayoutInquiryHistoryRoute
  '/customer/layout/map': typeof CustomerLayoutMapRoute
  '/customer/layout/map-list': typeof CustomerLayoutMapListRoute
  '/customer/layout/member-code': typeof CustomerLayoutMemberCodeRoute
  '/customer/layout/reservation': typeof CustomerLayoutReservationRoute
  '/customer/layout/reservation-with-subscription': typeof CustomerLayoutReservationWithSubscriptionRoute
  '/customer/layout/search': typeof CustomerLayoutSearchRoute
  '/customer/layout/subscription-list': typeof CustomerLayoutSubscriptionListRoute
  '/customer/layout/to-school': typeof CustomerLayoutToSchoolRoute
  '/customer/layout/user': typeof CustomerLayoutUserRoute
  '/customer/layout/user-announcement': typeof CustomerLayoutUserAnnouncementRoute
  '/customer/layout/user-announcement-detail': typeof CustomerLayoutUserAnnouncementDetailRoute
  '/customer/layout/user-buy-coin': typeof CustomerLayoutUserBuyCoinRoute
  '/customer/layout/user-contract': typeof CustomerLayoutUserContractRoute
  '/customer/layout/user-contract-detail': typeof CustomerLayoutUserContractDetailRoute
  '/customer/layout/user-guardian-link': typeof CustomerLayoutUserGuardianLinkRoute
  '/customer/layout/user-info-Chg': typeof CustomerLayoutUserInfoChgRoute
  '/customer/layout/user-pet-info': typeof CustomerLayoutUserPetInfoRoute
  '/customer/layout/user-pet-info-add': typeof CustomerLayoutUserPetInfoAddRoute
  '/customer/layout/user-pet-info-chg': typeof CustomerLayoutUserPetInfoChgRoute
  '/customer/layout/user-push': typeof CustomerLayoutUserPushRoute
  '/customer/layout/user-subscription-detail': typeof CustomerLayoutUserSubscriptionDetailRoute
  '/customer/layout/user-subscriptions': typeof CustomerLayoutUserSubscriptionsRoute
  '/customer/layout/user-usage-history': typeof CustomerLayoutUserUsageHistoryRoute
  '/customer/layout/user-usage-history-detail': typeof CustomerLayoutUserUsageHistoryDetailRoute
  '/oauth/google/callback': typeof OauthGoogleCallbackRoute
  '/business/layout/test': typeof BusinessLayoutTestLazyRoute
  '/customer/layout/test': typeof CustomerLayoutTestLazyRoute
  '/business/layout/payment/test': typeof BusinessLayoutPaymentTestRoute
  '/customer/layout/payment/auth': typeof CustomerLayoutPaymentAuthRoute
  '/customer/layout/payment/fail': typeof CustomerLayoutPaymentFailRoute
  '/customer/layout/payment/index copy': typeof CustomerLayoutPaymentIndexcopyRoute
  '/customer/layout/payment/success': typeof CustomerLayoutPaymentSuccessRoute
  '/customer/layout/payment/': typeof CustomerLayoutPaymentIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login-stage'
    | '/policy'
    | '/sign-up'
    | '/auth/handoff'
    | '/business/layout'
    | '/customer/alert'
    | '/customer/layout'
    | '/oauth/google'
    | '/oauth/kakao'
    | '/oauth/naver'
    | '/sign-up/business-owner'
    | '/sign-up/business-owner-detail'
    | '/sign-up/business-owner-done'
    | '/sign-up/business-teacher'
    | '/sign-up/business-teacher-done'
    | '/sign-up/customer'
    | '/sign-up/customer-done'
    | '/sign-up/pet'
    | '/sign-up/'
    | '/business/layout/about'
    | '/business/layout/calendar'
    | '/business/layout/company-photo-add'
    | '/business/layout/contract-request-detail'
    | '/business/layout/contract-request-send'
    | '/business/layout/contract-status'
    | '/business/layout/contract-template-edit'
    | '/business/layout/contract-template-import'
    | '/business/layout/contract-templates'
    | '/business/layout/gallery'
    | '/business/layout/gallery-add'
    | '/business/layout/home'
    | '/business/layout/manual-reserve'
    | '/business/layout/notify'
    | '/business/layout/notify-batch'
    | '/business/layout/notify-detail'
    | '/business/layout/notify-saved-notify'
    | '/business/layout/notify-send'
    | '/business/layout/notify-style'
    | '/business/layout/reservation-with-issued-ticket'
    | '/business/layout/revservation'
    | '/business/layout/seal-management'
    | '/business/layout/teacher'
    | '/business/layout/to-school'
    | '/business/layout/user'
    | '/business/layout/user-business-info'
    | '/business/layout/user-business-photo-management'
    | '/business/layout/user-business-time-management'
    | '/business/layout/user-contract-detail'
    | '/business/layout/user-contract-management'
    | '/business/layout/user-contract-managementOld'
    | '/business/layout/user-credit-wallet'
    | '/business/layout/user-credit-wallet-charge'
    | '/business/layout/user-credit-wallet-charge-fail'
    | '/business/layout/user-credit-wallet-charge-success'
    | '/business/layout/user-customer-info'
    | '/business/layout/user-customer-management'
    | '/business/layout/user-customer-management-detail'
    | '/business/layout/user-employee-detail'
    | '/business/layout/user-employee-management'
    | '/business/layout/user-owner-announcement'
    | '/business/layout/user-owner-announcement-detail'
    | '/business/layout/user-owner-info'
    | '/business/layout/user-owner-push'
    | '/business/layout/user-owner-setting'
    | '/business/layout/user-payment-history'
    | '/business/layout/user-product-management'
    | '/business/layout/user-service-statistics'
    | '/business/layout/user-subscription-add-edit'
    | '/business/layout/user-subscription-issue'
    | '/business/layout/user-subscription-issue-detail'
    | '/business/layout/user-subscription-issue-history'
    | '/business/layout/user-subscription-management'
    | '/business/layout/user-subscription-order-edit'
    | '/business/layout/user-teacher-info'
    | '/business/layout/user-teacher-push'
    | '/business/layout/user-teacher-setting'
    | '/customer/layout/about'
    | '/customer/layout/calendar'
    | '/customer/layout/calendar-reservation'
    | '/customer/layout/calendar-reservation-chg'
    | '/customer/layout/contract-inbox'
    | '/customer/layout/contract-sign'
    | '/customer/layout/gallery'
    | '/customer/layout/gallery-detail'
    | '/customer/layout/home'
    | '/customer/layout/home-alert'
    | '/customer/layout/home-serach-detail'
    | '/customer/layout/home-serach-store'
    | '/customer/layout/info-suggest'
    | '/customer/layout/inform'
    | '/customer/layout/inform-detail'
    | '/customer/layout/inform-send'
    | '/customer/layout/inform-send-fix'
    | '/customer/layout/inquiry-history'
    | '/customer/layout/map'
    | '/customer/layout/map-list'
    | '/customer/layout/member-code'
    | '/customer/layout/reservation'
    | '/customer/layout/reservation-with-subscription'
    | '/customer/layout/search'
    | '/customer/layout/subscription-list'
    | '/customer/layout/to-school'
    | '/customer/layout/user'
    | '/customer/layout/user-announcement'
    | '/customer/layout/user-announcement-detail'
    | '/customer/layout/user-buy-coin'
    | '/customer/layout/user-contract'
    | '/customer/layout/user-contract-detail'
    | '/customer/layout/user-guardian-link'
    | '/customer/layout/user-info-Chg'
    | '/customer/layout/user-pet-info'
    | '/customer/layout/user-pet-info-add'
    | '/customer/layout/user-pet-info-chg'
    | '/customer/layout/user-push'
    | '/customer/layout/user-subscription-detail'
    | '/customer/layout/user-subscriptions'
    | '/customer/layout/user-usage-history'
    | '/customer/layout/user-usage-history-detail'
    | '/oauth/google/callback'
    | '/business/layout/test'
    | '/customer/layout/test'
    | '/business/layout/payment/test'
    | '/customer/layout/payment/auth'
    | '/customer/layout/payment/fail'
    | '/customer/layout/payment/index copy'
    | '/customer/layout/payment/success'
    | '/customer/layout/payment'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login-stage'
    | '/policy'
    | '/auth/handoff'
    | '/business/layout'
    | '/customer/alert'
    | '/customer/layout'
    | '/oauth/google'
    | '/oauth/kakao'
    | '/oauth/naver'
    | '/sign-up/business-owner'
    | '/sign-up/business-owner-detail'
    | '/sign-up/business-owner-done'
    | '/sign-up/business-teacher'
    | '/sign-up/business-teacher-done'
    | '/sign-up/customer'
    | '/sign-up/customer-done'
    | '/sign-up/pet'
    | '/sign-up'
    | '/business/layout/about'
    | '/business/layout/calendar'
    | '/business/layout/company-photo-add'
    | '/business/layout/contract-request-detail'
    | '/business/layout/contract-request-send'
    | '/business/layout/contract-status'
    | '/business/layout/contract-template-edit'
    | '/business/layout/contract-template-import'
    | '/business/layout/contract-templates'
    | '/business/layout/gallery'
    | '/business/layout/gallery-add'
    | '/business/layout/home'
    | '/business/layout/manual-reserve'
    | '/business/layout/notify'
    | '/business/layout/notify-batch'
    | '/business/layout/notify-detail'
    | '/business/layout/notify-saved-notify'
    | '/business/layout/notify-send'
    | '/business/layout/notify-style'
    | '/business/layout/reservation-with-issued-ticket'
    | '/business/layout/revservation'
    | '/business/layout/seal-management'
    | '/business/layout/teacher'
    | '/business/layout/to-school'
    | '/business/layout/user'
    | '/business/layout/user-business-info'
    | '/business/layout/user-business-photo-management'
    | '/business/layout/user-business-time-management'
    | '/business/layout/user-contract-detail'
    | '/business/layout/user-contract-management'
    | '/business/layout/user-contract-managementOld'
    | '/business/layout/user-credit-wallet'
    | '/business/layout/user-credit-wallet-charge'
    | '/business/layout/user-credit-wallet-charge-fail'
    | '/business/layout/user-credit-wallet-charge-success'
    | '/business/layout/user-customer-info'
    | '/business/layout/user-customer-management'
    | '/business/layout/user-customer-management-detail'
    | '/business/layout/user-employee-detail'
    | '/business/layout/user-employee-management'
    | '/business/layout/user-owner-announcement'
    | '/business/layout/user-owner-announcement-detail'
    | '/business/layout/user-owner-info'
    | '/business/layout/user-owner-push'
    | '/business/layout/user-owner-setting'
    | '/business/layout/user-payment-history'
    | '/business/layout/user-product-management'
    | '/business/layout/user-service-statistics'
    | '/business/layout/user-subscription-add-edit'
    | '/business/layout/user-subscription-issue'
    | '/business/layout/user-subscription-issue-detail'
    | '/business/layout/user-subscription-issue-history'
    | '/business/layout/user-subscription-management'
    | '/business/layout/user-subscription-order-edit'
    | '/business/layout/user-teacher-info'
    | '/business/layout/user-teacher-push'
    | '/business/layout/user-teacher-setting'
    | '/customer/layout/about'
    | '/customer/layout/calendar'
    | '/customer/layout/calendar-reservation'
    | '/customer/layout/calendar-reservation-chg'
    | '/customer/layout/contract-inbox'
    | '/customer/layout/contract-sign'
    | '/customer/layout/gallery'
    | '/customer/layout/gallery-detail'
    | '/customer/layout/home'
    | '/customer/layout/home-alert'
    | '/customer/layout/home-serach-detail'
    | '/customer/layout/home-serach-store'
    | '/customer/layout/info-suggest'
    | '/customer/layout/inform'
    | '/customer/layout/inform-detail'
    | '/customer/layout/inform-send'
    | '/customer/layout/inform-send-fix'
    | '/customer/layout/inquiry-history'
    | '/customer/layout/map'
    | '/customer/layout/map-list'
    | '/customer/layout/member-code'
    | '/customer/layout/reservation'
    | '/customer/layout/reservation-with-subscription'
    | '/customer/layout/search'
    | '/customer/layout/subscription-list'
    | '/customer/layout/to-school'
    | '/customer/layout/user'
    | '/customer/layout/user-announcement'
    | '/customer/layout/user-announcement-detail'
    | '/customer/layout/user-buy-coin'
    | '/customer/layout/user-contract'
    | '/customer/layout/user-contract-detail'
    | '/customer/layout/user-guardian-link'
    | '/customer/layout/user-info-Chg'
    | '/customer/layout/user-pet-info'
    | '/customer/layout/user-pet-info-add'
    | '/customer/layout/user-pet-info-chg'
    | '/customer/layout/user-push'
    | '/customer/layout/user-subscription-detail'
    | '/customer/layout/user-subscriptions'
    | '/customer/layout/user-usage-history'
    | '/customer/layout/user-usage-history-detail'
    | '/oauth/google/callback'
    | '/business/layout/test'
    | '/customer/layout/test'
    | '/business/layout/payment/test'
    | '/customer/layout/payment/auth'
    | '/customer/layout/payment/fail'
    | '/customer/layout/payment/index copy'
    | '/customer/layout/payment/success'
    | '/customer/layout/payment'
  id:
    | '__root__'
    | '/'
    | '/login-stage'
    | '/policy'
    | '/sign-up'
    | '/auth/handoff'
    | '/business/layout'
    | '/customer/alert'
    | '/customer/layout'
    | '/oauth/google'
    | '/oauth/kakao'
    | '/oauth/naver'
    | '/sign-up/business-owner'
    | '/sign-up/business-owner-detail'
    | '/sign-up/business-owner-done'
    | '/sign-up/business-teacher'
    | '/sign-up/business-teacher-done'
    | '/sign-up/customer'
    | '/sign-up/customer-done'
    | '/sign-up/pet'
    | '/sign-up/'
    | '/business/layout/about'
    | '/business/layout/calendar'
    | '/business/layout/company-photo-add'
    | '/business/layout/contract-request-detail'
    | '/business/layout/contract-request-send'
    | '/business/layout/contract-status'
    | '/business/layout/contract-template-edit'
    | '/business/layout/contract-template-import'
    | '/business/layout/contract-templates'
    | '/business/layout/gallery'
    | '/business/layout/gallery-add'
    | '/business/layout/home'
    | '/business/layout/manual-reserve'
    | '/business/layout/notify'
    | '/business/layout/notify-batch'
    | '/business/layout/notify-detail'
    | '/business/layout/notify-saved-notify'
    | '/business/layout/notify-send'
    | '/business/layout/notify-style'
    | '/business/layout/reservation-with-issued-ticket'
    | '/business/layout/revservation'
    | '/business/layout/seal-management'
    | '/business/layout/teacher'
    | '/business/layout/to-school'
    | '/business/layout/user'
    | '/business/layout/user-business-info'
    | '/business/layout/user-business-photo-management'
    | '/business/layout/user-business-time-management'
    | '/business/layout/user-contract-detail'
    | '/business/layout/user-contract-management'
    | '/business/layout/user-contract-managementOld'
    | '/business/layout/user-credit-wallet'
    | '/business/layout/user-credit-wallet-charge'
    | '/business/layout/user-credit-wallet-charge-fail'
    | '/business/layout/user-credit-wallet-charge-success'
    | '/business/layout/user-customer-info'
    | '/business/layout/user-customer-management'
    | '/business/layout/user-customer-management-detail'
    | '/business/layout/user-employee-detail'
    | '/business/layout/user-employee-management'
    | '/business/layout/user-owner-announcement'
    | '/business/layout/user-owner-announcement-detail'
    | '/business/layout/user-owner-info'
    | '/business/layout/user-owner-push'
    | '/business/layout/user-owner-setting'
    | '/business/layout/user-payment-history'
    | '/business/layout/user-product-management'
    | '/business/layout/user-service-statistics'
    | '/business/layout/user-subscription-add-edit'
    | '/business/layout/user-subscription-issue'
    | '/business/layout/user-subscription-issue-detail'
    | '/business/layout/user-subscription-issue-history'
    | '/business/layout/user-subscription-management'
    | '/business/layout/user-subscription-order-edit'
    | '/business/layout/user-teacher-info'
    | '/business/layout/user-teacher-push'
    | '/business/layout/user-teacher-setting'
    | '/customer/layout/about'
    | '/customer/layout/calendar'
    | '/customer/layout/calendar-reservation'
    | '/customer/layout/calendar-reservation-chg'
    | '/customer/layout/contract-inbox'
    | '/customer/layout/contract-sign'
    | '/customer/layout/gallery'
    | '/customer/layout/gallery-detail'
    | '/customer/layout/home'
    | '/customer/layout/home-alert'
    | '/customer/layout/home-serach-detail'
    | '/customer/layout/home-serach-store'
    | '/customer/layout/info-suggest'
    | '/customer/layout/inform'
    | '/customer/layout/inform-detail'
    | '/customer/layout/inform-send'
    | '/customer/layout/inform-send-fix'
    | '/customer/layout/inquiry-history'
    | '/customer/layout/map'
    | '/customer/layout/map-list'
    | '/customer/layout/member-code'
    | '/customer/layout/reservation'
    | '/customer/layout/reservation-with-subscription'
    | '/customer/layout/search'
    | '/customer/layout/subscription-list'
    | '/customer/layout/to-school'
    | '/customer/layout/user'
    | '/customer/layout/user-announcement'
    | '/customer/layout/user-announcement-detail'
    | '/customer/layout/user-buy-coin'
    | '/customer/layout/user-contract'
    | '/customer/layout/user-contract-detail'
    | '/customer/layout/user-guardian-link'
    | '/customer/layout/user-info-Chg'
    | '/customer/layout/user-pet-info'
    | '/customer/layout/user-pet-info-add'
    | '/customer/layout/user-pet-info-chg'
    | '/customer/layout/user-push'
    | '/customer/layout/user-subscription-detail'
    | '/customer/layout/user-subscriptions'
    | '/customer/layout/user-usage-history'
    | '/customer/layout/user-usage-history-detail'
    | '/oauth/google/callback'
    | '/business/layout/test'
    | '/customer/layout/test'
    | '/business/layout/payment/test'
    | '/customer/layout/payment/auth'
    | '/customer/layout/payment/fail'
    | '/customer/layout/payment/index copy'
    | '/customer/layout/payment/success'
    | '/customer/layout/payment/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginStageRoute: typeof LoginStageRoute
  PolicyRoute: typeof PolicyRoute
  SignUpRoute: typeof SignUpRouteWithChildren
  AuthHandoffRoute: typeof AuthHandoffRoute
  BusinessLayoutRoute: typeof BusinessLayoutRouteWithChildren
  CustomerAlertRoute: typeof CustomerAlertRoute
  CustomerLayoutRoute: typeof CustomerLayoutRouteWithChildren
  OauthGoogleRoute: typeof OauthGoogleRouteWithChildren
  OauthKakaoRoute: typeof OauthKakaoRoute
  OauthNaverRoute: typeof OauthNaverRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginStageRoute: LoginStageRoute,
  PolicyRoute: PolicyRoute,
  SignUpRoute: SignUpRouteWithChildren,
  AuthHandoffRoute: AuthHandoffRoute,
  BusinessLayoutRoute: BusinessLayoutRouteWithChildren,
  CustomerAlertRoute: CustomerAlertRoute,
  CustomerLayoutRoute: CustomerLayoutRouteWithChildren,
  OauthGoogleRoute: OauthGoogleRouteWithChildren,
  OauthKakaoRoute: OauthKakaoRoute,
  OauthNaverRoute: OauthNaverRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/login-stage",
        "/policy",
        "/sign-up",
        "/auth/handoff",
        "/business/layout",
        "/customer/alert",
        "/customer/layout",
        "/oauth/google",
        "/oauth/kakao",
        "/oauth/naver"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/login-stage": {
      "filePath": "login-stage.tsx"
    },
    "/policy": {
      "filePath": "policy.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.tsx",
      "children": [
        "/sign-up/business-owner",
        "/sign-up/business-owner-detail",
        "/sign-up/business-owner-done",
        "/sign-up/business-teacher",
        "/sign-up/business-teacher-done",
        "/sign-up/customer",
        "/sign-up/customer-done",
        "/sign-up/pet",
        "/sign-up/"
      ]
    },
    "/auth/handoff": {
      "filePath": "auth/handoff.tsx"
    },
    "/business/layout": {
      "filePath": "business/layout.tsx",
      "children": [
        "/business/layout/about",
        "/business/layout/calendar",
        "/business/layout/company-photo-add",
        "/business/layout/contract-request-detail",
        "/business/layout/contract-request-send",
        "/business/layout/contract-status",
        "/business/layout/contract-template-edit",
        "/business/layout/contract-template-import",
        "/business/layout/contract-templates",
        "/business/layout/gallery",
        "/business/layout/gallery-add",
        "/business/layout/home",
        "/business/layout/manual-reserve",
        "/business/layout/notify",
        "/business/layout/notify-batch",
        "/business/layout/notify-detail",
        "/business/layout/notify-saved-notify",
        "/business/layout/notify-send",
        "/business/layout/notify-style",
        "/business/layout/reservation-with-issued-ticket",
        "/business/layout/revservation",
        "/business/layout/seal-management",
        "/business/layout/teacher",
        "/business/layout/to-school",
        "/business/layout/user",
        "/business/layout/user-business-info",
        "/business/layout/user-business-photo-management",
        "/business/layout/user-business-time-management",
        "/business/layout/user-contract-detail",
        "/business/layout/user-contract-management",
        "/business/layout/user-contract-managementOld",
        "/business/layout/user-credit-wallet",
        "/business/layout/user-credit-wallet-charge",
        "/business/layout/user-credit-wallet-charge-fail",
        "/business/layout/user-credit-wallet-charge-success",
        "/business/layout/user-customer-info",
        "/business/layout/user-customer-management",
        "/business/layout/user-customer-management-detail",
        "/business/layout/user-employee-detail",
        "/business/layout/user-employee-management",
        "/business/layout/user-owner-announcement",
        "/business/layout/user-owner-announcement-detail",
        "/business/layout/user-owner-info",
        "/business/layout/user-owner-push",
        "/business/layout/user-owner-setting",
        "/business/layout/user-payment-history",
        "/business/layout/user-product-management",
        "/business/layout/user-service-statistics",
        "/business/layout/user-subscription-add-edit",
        "/business/layout/user-subscription-issue",
        "/business/layout/user-subscription-issue-detail",
        "/business/layout/user-subscription-issue-history",
        "/business/layout/user-subscription-management",
        "/business/layout/user-subscription-order-edit",
        "/business/layout/user-teacher-info",
        "/business/layout/user-teacher-push",
        "/business/layout/user-teacher-setting",
        "/business/layout/test",
        "/business/layout/payment/test"
      ]
    },
    "/customer/alert": {
      "filePath": "customer/alert.tsx"
    },
    "/customer/layout": {
      "filePath": "customer/layout.tsx",
      "children": [
        "/customer/layout/about",
        "/customer/layout/calendar",
        "/customer/layout/calendar-reservation",
        "/customer/layout/calendar-reservation-chg",
        "/customer/layout/contract-inbox",
        "/customer/layout/contract-sign",
        "/customer/layout/gallery",
        "/customer/layout/gallery-detail",
        "/customer/layout/home",
        "/customer/layout/home-alert",
        "/customer/layout/home-serach-detail",
        "/customer/layout/home-serach-store",
        "/customer/layout/info-suggest",
        "/customer/layout/inform",
        "/customer/layout/inform-detail",
        "/customer/layout/inform-send",
        "/customer/layout/inform-send-fix",
        "/customer/layout/inquiry-history",
        "/customer/layout/map",
        "/customer/layout/map-list",
        "/customer/layout/member-code",
        "/customer/layout/reservation",
        "/customer/layout/reservation-with-subscription",
        "/customer/layout/search",
        "/customer/layout/subscription-list",
        "/customer/layout/to-school",
        "/customer/layout/user",
        "/customer/layout/user-announcement",
        "/customer/layout/user-announcement-detail",
        "/customer/layout/user-buy-coin",
        "/customer/layout/user-contract",
        "/customer/layout/user-contract-detail",
        "/customer/layout/user-guardian-link",
        "/customer/layout/user-info-Chg",
        "/customer/layout/user-pet-info",
        "/customer/layout/user-pet-info-add",
        "/customer/layout/user-pet-info-chg",
        "/customer/layout/user-push",
        "/customer/layout/user-subscription-detail",
        "/customer/layout/user-subscriptions",
        "/customer/layout/user-usage-history",
        "/customer/layout/user-usage-history-detail",
        "/customer/layout/test",
        "/customer/layout/payment/auth",
        "/customer/layout/payment/fail",
        "/customer/layout/payment/index copy",
        "/customer/layout/payment/success",
        "/customer/layout/payment/"
      ]
    },
    "/oauth/google": {
      "filePath": "oauth/google.tsx",
      "children": [
        "/oauth/google/callback"
      ]
    },
    "/oauth/kakao": {
      "filePath": "oauth/kakao.tsx"
    },
    "/oauth/naver": {
      "filePath": "oauth/naver.tsx"
    },
    "/sign-up/business-owner": {
      "filePath": "sign-up/business-owner.tsx",
      "parent": "/sign-up"
    },
    "/sign-up/business-owner-detail": {
      "filePath": "sign-up/business-owner-detail.tsx",
      "parent": "/sign-up"
    },
    "/sign-up/business-owner-done": {
      "filePath": "sign-up/business-owner-done.tsx",
      "parent": "/sign-up"
    },
    "/sign-up/business-teacher": {
      "filePath": "sign-up/business-teacher.tsx",
      "parent": "/sign-up"
    },
    "/sign-up/business-teacher-done": {
      "filePath": "sign-up/business-teacher-done.tsx",
      "parent": "/sign-up"
    },
    "/sign-up/customer": {
      "filePath": "sign-up/customer.tsx",
      "parent": "/sign-up"
    },
    "/sign-up/customer-done": {
      "filePath": "sign-up/customer-done.tsx",
      "parent": "/sign-up"
    },
    "/sign-up/pet": {
      "filePath": "sign-up/pet.tsx",
      "parent": "/sign-up"
    },
    "/sign-up/": {
      "filePath": "sign-up/index.tsx",
      "parent": "/sign-up"
    },
    "/business/layout/about": {
      "filePath": "business/layout/about.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/calendar": {
      "filePath": "business/layout/calendar.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/company-photo-add": {
      "filePath": "business/layout/company-photo-add.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/contract-request-detail": {
      "filePath": "business/layout/contract-request-detail.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/contract-request-send": {
      "filePath": "business/layout/contract-request-send.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/contract-status": {
      "filePath": "business/layout/contract-status.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/contract-template-edit": {
      "filePath": "business/layout/contract-template-edit.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/contract-template-import": {
      "filePath": "business/layout/contract-template-import.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/contract-templates": {
      "filePath": "business/layout/contract-templates.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/gallery": {
      "filePath": "business/layout/gallery.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/gallery-add": {
      "filePath": "business/layout/gallery-add.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/home": {
      "filePath": "business/layout/home.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/manual-reserve": {
      "filePath": "business/layout/manual-reserve.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/notify": {
      "filePath": "business/layout/notify.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/notify-batch": {
      "filePath": "business/layout/notify-batch.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/notify-detail": {
      "filePath": "business/layout/notify-detail.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/notify-saved-notify": {
      "filePath": "business/layout/notify-saved-notify.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/notify-send": {
      "filePath": "business/layout/notify-send.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/notify-style": {
      "filePath": "business/layout/notify-style.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/reservation-with-issued-ticket": {
      "filePath": "business/layout/reservation-with-issued-ticket.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/revservation": {
      "filePath": "business/layout/revservation.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/seal-management": {
      "filePath": "business/layout/seal-management.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/teacher": {
      "filePath": "business/layout/teacher.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/to-school": {
      "filePath": "business/layout/to-school.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user": {
      "filePath": "business/layout/user.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-business-info": {
      "filePath": "business/layout/user-business-info.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-business-photo-management": {
      "filePath": "business/layout/user-business-photo-management.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-business-time-management": {
      "filePath": "business/layout/user-business-time-management.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-contract-detail": {
      "filePath": "business/layout/user-contract-detail.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-contract-management": {
      "filePath": "business/layout/user-contract-management.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-contract-managementOld": {
      "filePath": "business/layout/user-contract-managementOld.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-credit-wallet": {
      "filePath": "business/layout/user-credit-wallet.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-credit-wallet-charge": {
      "filePath": "business/layout/user-credit-wallet-charge.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-credit-wallet-charge-fail": {
      "filePath": "business/layout/user-credit-wallet-charge-fail.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-credit-wallet-charge-success": {
      "filePath": "business/layout/user-credit-wallet-charge-success.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-customer-info": {
      "filePath": "business/layout/user-customer-info.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-customer-management": {
      "filePath": "business/layout/user-customer-management.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-customer-management-detail": {
      "filePath": "business/layout/user-customer-management-detail.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-employee-detail": {
      "filePath": "business/layout/user-employee-detail.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-employee-management": {
      "filePath": "business/layout/user-employee-management.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-owner-announcement": {
      "filePath": "business/layout/user-owner-announcement.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-owner-announcement-detail": {
      "filePath": "business/layout/user-owner-announcement-detail.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-owner-info": {
      "filePath": "business/layout/user-owner-info.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-owner-push": {
      "filePath": "business/layout/user-owner-push.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-owner-setting": {
      "filePath": "business/layout/user-owner-setting.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-payment-history": {
      "filePath": "business/layout/user-payment-history.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-product-management": {
      "filePath": "business/layout/user-product-management.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-service-statistics": {
      "filePath": "business/layout/user-service-statistics.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-subscription-add-edit": {
      "filePath": "business/layout/user-subscription-add-edit.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-subscription-issue": {
      "filePath": "business/layout/user-subscription-issue.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-subscription-issue-detail": {
      "filePath": "business/layout/user-subscription-issue-detail.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-subscription-issue-history": {
      "filePath": "business/layout/user-subscription-issue-history.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-subscription-management": {
      "filePath": "business/layout/user-subscription-management.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-subscription-order-edit": {
      "filePath": "business/layout/user-subscription-order-edit.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-teacher-info": {
      "filePath": "business/layout/user-teacher-info.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-teacher-push": {
      "filePath": "business/layout/user-teacher-push.tsx",
      "parent": "/business/layout"
    },
    "/business/layout/user-teacher-setting": {
      "filePath": "business/layout/user-teacher-setting.tsx",
      "parent": "/business/layout"
    },
    "/customer/layout/about": {
      "filePath": "customer/layout/about.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/calendar": {
      "filePath": "customer/layout/calendar.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/calendar-reservation": {
      "filePath": "customer/layout/calendar-reservation.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/calendar-reservation-chg": {
      "filePath": "customer/layout/calendar-reservation-chg.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/contract-inbox": {
      "filePath": "customer/layout/contract-inbox.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/contract-sign": {
      "filePath": "customer/layout/contract-sign.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/gallery": {
      "filePath": "customer/layout/gallery.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/gallery-detail": {
      "filePath": "customer/layout/gallery-detail.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/home": {
      "filePath": "customer/layout/home.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/home-alert": {
      "filePath": "customer/layout/home-alert.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/home-serach-detail": {
      "filePath": "customer/layout/home-serach-detail.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/home-serach-store": {
      "filePath": "customer/layout/home-serach-store.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/info-suggest": {
      "filePath": "customer/layout/info-suggest.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/inform": {
      "filePath": "customer/layout/inform.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/inform-detail": {
      "filePath": "customer/layout/inform-detail.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/inform-send": {
      "filePath": "customer/layout/inform-send.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/inform-send-fix": {
      "filePath": "customer/layout/inform-send-fix.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/inquiry-history": {
      "filePath": "customer/layout/inquiry-history.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/map": {
      "filePath": "customer/layout/map.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/map-list": {
      "filePath": "customer/layout/map-list.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/member-code": {
      "filePath": "customer/layout/member-code.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/reservation": {
      "filePath": "customer/layout/reservation.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/reservation-with-subscription": {
      "filePath": "customer/layout/reservation-with-subscription.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/search": {
      "filePath": "customer/layout/search.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/subscription-list": {
      "filePath": "customer/layout/subscription-list.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/to-school": {
      "filePath": "customer/layout/to-school.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user": {
      "filePath": "customer/layout/user.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-announcement": {
      "filePath": "customer/layout/user-announcement.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-announcement-detail": {
      "filePath": "customer/layout/user-announcement-detail.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-buy-coin": {
      "filePath": "customer/layout/user-buy-coin.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-contract": {
      "filePath": "customer/layout/user-contract.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-contract-detail": {
      "filePath": "customer/layout/user-contract-detail.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-guardian-link": {
      "filePath": "customer/layout/user-guardian-link.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-info-Chg": {
      "filePath": "customer/layout/user-info-Chg.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-pet-info": {
      "filePath": "customer/layout/user-pet-info.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-pet-info-add": {
      "filePath": "customer/layout/user-pet-info-add.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-pet-info-chg": {
      "filePath": "customer/layout/user-pet-info-chg.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-push": {
      "filePath": "customer/layout/user-push.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-subscription-detail": {
      "filePath": "customer/layout/user-subscription-detail.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-subscriptions": {
      "filePath": "customer/layout/user-subscriptions.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-usage-history": {
      "filePath": "customer/layout/user-usage-history.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/user-usage-history-detail": {
      "filePath": "customer/layout/user-usage-history-detail.tsx",
      "parent": "/customer/layout"
    },
    "/oauth/google/callback": {
      "filePath": "oauth/google/callback.tsx",
      "parent": "/oauth/google"
    },
    "/business/layout/test": {
      "filePath": "business/layout/test.lazy.tsx",
      "parent": "/business/layout"
    },
    "/customer/layout/test": {
      "filePath": "customer/layout/test.lazy.tsx",
      "parent": "/customer/layout"
    },
    "/business/layout/payment/test": {
      "filePath": "business/layout/payment/test.tsx",
      "parent": "/business/layout"
    },
    "/customer/layout/payment/auth": {
      "filePath": "customer/layout/payment/auth.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/payment/fail": {
      "filePath": "customer/layout/payment/fail.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/payment/index copy": {
      "filePath": "customer/layout/payment/index copy.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/payment/success": {
      "filePath": "customer/layout/payment/success.tsx",
      "parent": "/customer/layout"
    },
    "/customer/layout/payment/": {
      "filePath": "customer/layout/payment/index.tsx",
      "parent": "/customer/layout"
    }
  }
}
ROUTE_MANIFEST_END */
